import React from "react"

export const EnvelopeResendIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.6019 7.67918V3.24536" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M12.0465 12.9868L10.2687 14.7643L12.0465 16.5417"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8233 1.45825H2.28731C1.29976 1.45825 0.499756 2.2581 0.499756 3.24547V3.24547C0.499756 3.83824 0.793978 4.39191 1.28464 4.72429L6.04642 7.95123C7.25976 8.7733 8.85265 8.7733 10.066 7.95123L14.8269 4.72518C15.3166 4.3928 15.6109 3.83824 15.6109 3.24635V3.24547C15.6109 2.2581 14.8109 1.45825 13.8233 1.45825V1.45825Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.61087 13.0115H2.27753C1.29531 13.0115 0.499756 12.2161 0.499756 11.2341V3.24536"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.8331 11.2341H14.722C15.7042 11.2341 16.4998 12.0295 16.4998 13.0116V13.0116C16.4998 13.9936 15.7042 14.789 14.722 14.789H14.2865H14.722H10.2687"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.91897 2.51539C11.9593 4.5359 11.9593 7.81181 9.91897 9.83233C7.87864 11.8528 4.57059 11.8528 2.53025 9.83233C0.489915 7.81181 0.489915 4.5359 2.53025 2.51539C4.57059 0.494871 7.87864 0.494871 9.91897 2.51539"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.8811 9.86157L14.9998 14.9999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
export const ArchiveIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="20" {...props} height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3 6.5H3.7C3.3136 6.5 3 6.1864 3 5.8V4.4C3 4.0136 3.3136 3.7 3.7 3.7H16.3C16.6864 3.7 17 4.0136 17 4.4V5.8C17 6.1864 16.6864 6.5 16.3 6.5Z"
            fill="currentColor"
            fillOpacity="0.1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M7.90015 9.3H12.1001Z" fill="currentColor" fillOpacity="0.1" />
        <path d="M7.90015 9.3H12.1001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0669 6.49996V14.9C16.0669 15.6735 15.4404 16.3 14.6669 16.3H5.33311C4.55961 16.3 3.93311 15.6735 3.93311 14.9V6.49996"
            fill="currentColor"
            fillOpacity="0.1"
        />
        <path
            d="M16.0669 6.49996V14.9C16.0669 15.6735 15.4404 16.3 14.6669 16.3H5.33311C4.55961 16.3 3.93311 15.6735 3.93311 14.9V6.49996"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const CoinsIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 9V5H9.5V9" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.5 5H10.5V1H2.5V5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M13.3284 10.1716C14.8905 11.7337 14.8905 14.2663 13.3284 15.8284C11.7663 17.3905 9.23366 17.3905 7.67157 15.8284C6.10947 14.2663 6.10947 11.7337 7.67157 10.1716C9.23367 8.60947 11.7663 8.60947 13.3284 10.1716"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1.5 13V17H10.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.5 9H0.5V13H6.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ReceiptIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.88301 7.44434L8.15501 9.17234L7.11768 8.135"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.83337 11.8888H11.1667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.6543 16.3333V1.85941C15.6543 1.69929 15.5682 1.55155 15.4289 1.47266C15.2895 1.39377 15.1185 1.39593 14.9812 1.47831L13.7269 2.23088C13.4454 2.39978 13.0937 2.39978 12.8123 2.23088L11.3422 1.34884C11.0607 1.17994 10.709 1.17994 10.4275 1.34884L8.95747 2.23088C8.67597 2.39978 8.3243 2.39978 8.0428 2.23088L6.57274 1.34884C6.29124 1.17994 5.93957 1.17994 5.65807 1.34884L4.18801 2.23088C3.90651 2.39978 3.55484 2.39978 3.27334 2.23088L2.01906 1.47831C1.88176 1.39593 1.71075 1.39377 1.57142 1.47266C1.43208 1.55155 1.34595 1.69929 1.34595 1.85941V16.3333"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.5 16.3334H0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const EnvelopeOpenErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.5052 8.73041V2.24444C14.5052 1.55716 13.9481 1 13.2608 1H3.30524C2.61795 1 2.06079 1.55716 2.06079 2.24444V8.39822"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.61114 4.77783L7.38892 7.00005" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.61114 7.00005L7.38892 4.77783" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 9.00303C16.5 8.66473 16.308 8.35574 16.0047 8.20598C15.7013 8.05621 15.3392 8.09164 15.0707 8.29737L9.60359 12.4839C8.95226 12.9827 8.04737 12.9827 7.39605 12.4839C7.39605 12.4839 3.94599 9.84188 1.92642 8.29555C1.65776 8.09031 1.29584 8.05552 0.993009 8.20582C0.690175 8.35612 0.499018 8.6654 0.500004 9.00348V15.2223C0.500004 16.2042 1.29594 17.0001 2.27778 17.0001H14.722C15.7039 17.0001 16.4998 16.2042 16.4998 15.2223C16.4998 15.2223 16.4998 11.4501 16.5 9.00303Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UserCircleShieldIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1666 12.9584V13.7127C11.1666 15.1022 12.0285 16.346 13.3295 16.8339L13.7162 16.9789C13.7917 17.0072 13.8749 17.0072 13.9503 16.9789L14.337 16.8339C15.6381 16.346 16.5 15.1022 16.5 13.7127V12.9584C16.5 12.6668 16.3105 12.4091 16.0321 12.3221L14.0321 11.6971C13.9027 11.6566 13.7639 11.6566 13.6344 11.6971L11.6344 12.3221C11.3561 12.4091 11.1666 12.6668 11.1666 12.9584V12.9584Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.91615 12.5557C6.01344 12.5557 4.18867 13.3116 2.84326 14.657"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5 8.99999C16.5 4.58172 12.9183 1 8.49999 1C4.08172 1 0.5 4.58172 0.5 8.99999C0.5 13.4183 4.08172 17 8.49999 17"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.1667 6.99992V7.44436V7.44436C11.1667 8.91712 9.9728 10.111 8.50004 10.111V10.111C7.02728 10.111 5.83337 8.91712 5.83337 7.44436V7.44436V6.99992V6.99992C5.83337 5.52716 7.02728 4.33325 8.50004 4.33325V4.33325C9.9728 4.33325 11.1667 5.52716 11.1667 6.99992V6.99992Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeOpenAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3031 6.13109L10.0809 1.36631C9.44308 0.877895 8.55698 0.877895 7.91917 1.36631L1.69694 6.13112C1.25762 6.46753 0.999992 6.98931 1 7.54264V14.3333C1 15.8061 2.19391 17 3.66667 17H14.3333C15.8061 17 17 15.8061 17 14.3333V7.54259C17 6.98928 16.7424 6.46751 16.3031 6.13109Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.66663 6.33336H10.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.99999 7.66667V5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M1.16663 6.7925L7.91898 11.9633C8.5568 12.4517 9.4429 12.4517 10.0807 11.9633L16.8344 6.7915"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.9999 0.5L5.99988 11.5L0.999878 6.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UserCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.6226 15.1423L13.3115 14.361C13.1541 13.9646 12.9097 13.609 12.5968 13.3192L12.5399 13.2668C12.0475 12.8099 11.4004 12.5557 10.7284 12.5557H6.27146C5.59946 12.5557 4.95234 12.8099 4.45901 13.2659L4.40212 13.3192C4.08923 13.609 3.84568 13.9646 3.68745 14.361L3.37634 15.1423"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.6999 4.95322C11.9149 6.16819 11.9149 8.13803 10.6999 9.353C9.48496 10.568 7.51511 10.568 6.30014 9.353C5.08517 8.13803 5.08517 6.16819 6.30014 4.95322C7.51511 3.73825 9.48496 3.73825 10.6999 4.95322"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.1569 3.34315C17.281 6.46735 17.281 11.5327 14.1569 14.6569C11.0327 17.781 5.96733 17.781 2.84315 14.6569C-0.28105 11.5327 -0.28105 6.46733 2.84315 3.34315C5.96735 0.21895 11.0327 0.21895 14.1569 3.34315"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UsersGroupIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.8943 4.19948C15.4689 4.77405 15.4689 5.7056 14.8943 6.28017C14.3197 6.85474 13.3882 6.85474 12.8136 6.28017C12.239 5.7056 12.239 4.77405 12.8136 4.19948C13.3882 3.62491 14.3197 3.62491 14.8943 4.19948"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.1016 1.5732C10.9863 2.45792 10.9863 3.89232 10.1016 4.77704C9.21691 5.66176 7.78251 5.66176 6.89779 4.77704C6.01307 3.89233 6.01307 2.45792 6.89779 1.5732C7.7825 0.68849 9.21691 0.68849 10.1016 1.5732"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.18618 4.19948C4.76075 4.77405 4.76075 5.7056 4.18618 6.28017C3.61161 6.85474 2.68005 6.85474 2.10549 6.28017C1.53092 5.7056 1.53092 4.77405 2.10549 4.19948C2.68005 3.62491 3.61161 3.62491 4.18618 4.19948"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5001 11.0916V10.2945C16.5001 9.29014 15.6863 8.47632 14.6819 8.47632H14.0994"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.499878 11.0916V10.2945C0.499878 9.29014 1.3137 8.47632 2.31806 8.47632H2.90061"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.3829 11.0914V9.92705C12.3829 8.52123 11.2432 7.38159 9.83742 7.38159H7.16179C5.75597 7.38159 4.61633 8.52123 4.61633 9.92705V11.0914"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeCloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.499878 2.37881V2.37881C0.499878 2.91214 0.766545 3.35659 1.21099 3.71214L6.54432 7.35659C7.78877 8.15659 9.29988 8.15659 10.5443 7.35659L15.8777 3.80103C16.2332 3.35659 16.4999 2.91214 16.4999 2.37881V2.37881C16.4999 1.48992 15.7888 0.778809 14.8999 0.778809H2.09988C1.21099 0.778809 0.499878 1.48992 0.499878 2.37881Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.499878 2.55664V11.4455C0.499878 12.4233 1.29988 13.2233 2.27766 13.2233H14.7221C15.6999 13.2233 16.4999 12.4233 16.4999 11.4455V2.55664"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1.02246 12.7006L6.43935 7.28369" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.5975 7.32104L15.9771 12.7006" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ArrowUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.5 5.00098L4.5 1.00098L0.5 5.00098"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const PauseIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.8335 11.001V11.001C8.1435 11.001 7.5835 10.441 7.5835 9.75098V2.25098C7.5835 1.56098 8.1435 1.00098 8.8335 1.00098V1.00098C9.5235 1.00098 10.0835 1.56098 10.0835 2.25098V9.75098C10.0835 10.441 9.5235 11.001 8.8335 11.001Z"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.16663 11.001V11.001C1.47663 11.001 0.916626 10.441 0.916626 9.75098V2.25098C0.916626 1.56098 1.47663 1.00098 2.16663 1.00098V1.00098C2.85663 1.00098 3.41663 1.56098 3.41663 2.25098V9.75098C3.41663 10.441 2.85663 11.001 2.16663 11.001Z"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const PuzzlePieceCheck = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.66683 8.15711C3.29883 8.08216 2.89967 8.09648 2.48787 8.23374C1.79145 8.46617 1.23986 9.06491 1.06723 9.77902C0.711859 11.2468 1.81418 12.5571 3.2222 12.5571C3.37462 12.5571 3.52283 12.5411 3.66683 12.5125V15.2241C3.66683 16.2052 4.46263 17.001 5.44453 17.001H15.2223C16.2042 17.001 17 16.2052 17 15.2233V5.44551C17 4.4636 16.2042 3.66781 15.2223 3.66781H12.5107C12.5856 3.29981 12.5713 2.90064 12.4341 2.48885C12.2008 1.79242 11.6021 1.24084 10.8888 1.06821C9.42099 0.712836 8.11066 1.81516 8.11066 3.22317C8.11066 3.3756 8.12666 3.52381 8.15529 3.66781H5.44369C4.46179 3.66781 3.66599 4.4636 3.66599 5.44551V8.15711H3.66683Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.3691 8.6582L10.0002 11.0271L8.57874 9.60642"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BadgeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.2777 1.00244V2.60244C4.25551 2.87171 4.45329 3.10904 4.72214 3.13577H8.2777C8.54655 3.10904 8.74433 2.87171 8.72214 2.60244V1.00244"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.72205 14.3358H8.2776" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.0555 17.0024H2.9444C1.96256 17.0024 1.16663 16.2065 1.16663 15.2247V2.78022C1.16663 1.79838 1.96256 1.00244 2.9444 1.00244H10.0555C11.0374 1.00244 11.8333 1.79838 11.8333 2.78022V15.2247C11.8333 16.2065 11.0374 17.0024 10.0555 17.0024Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 17.0026V17.0026C4.58133 17.0026 1 13.4212 1 9.00256V9.00256C1 4.5839 4.58133 1.00256 9 1.00256V1.00256C13.4187 1.00256 17 4.5839 17 9.00256V9.00256C17 13.4212 13.4187 17.0026 9 17.0026Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CameraIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.5591 6.37395C12.9432 7.75797 12.9432 10.0019 11.5591 11.3859C10.1751 12.7699 7.93119 12.7699 6.54717 11.3859C5.16315 10.0019 5.16315 7.75797 6.54717 6.37395C7.93119 4.98993 10.1751 4.98993 11.5591 6.37395"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 5.33592V13.3359C17 14.3181 16.2044 15.1137 15.2222 15.1137H2.77778C1.79556 15.1137 1 14.3181 1 13.3359V5.33592C1 4.3537 1.79556 3.55815 2.77778 3.55815H4.55556L5.85511 1.33237C6.01422 1.05948 6.30667 0.891479 6.62311 0.891479H11.3378C11.6498 0.891479 11.9387 1.05504 12.0996 1.3217L13.4444 3.55815H15.2222C16.2044 3.55815 17 4.3537 17 5.33592Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const LinkIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.8046 9.68905L15.8631 7.63048C17.3791 6.11457 17.3791 3.65629 15.8631 2.1395V2.1395C14.3472 0.623586 11.889 0.623586 10.3722 2.1395L8.3136 4.19806"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.25586 11.7468L11.7442 6.25842" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M4.1955 8.31616L2.13693 10.3747C0.621022 11.8906 0.621022 14.3489 2.13693 15.8657V15.8657C3.65284 17.3816 6.11112 17.3816 7.62792 15.8657L9.68648 13.8071"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TextErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 1.25256H12.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.50012 13.2526V1.25256" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.4999 15.2526L12.4999 11.2526" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.4999 15.2526L16.4999 11.2526" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const PostalBoxIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.39954 13.8026V17.0026H9.59954V13.8026"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.19958 9.00254H3.99958" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3996 5.80261H3.59956C2.05316 5.80261 0.799561 7.05621 0.799561 8.60261V13.0026C0.799561 13.4442 1.15796 13.8026 1.59956 13.8026H14.3996C14.8412 13.8026 15.1996 13.4442 15.1996 13.0026V8.60261C15.1996 7.05621 13.946 5.80261 12.3996 5.80261Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.59958 3.40259V9.00259" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="9.59961"
            y="1.00256"
            width="4"
            height="2.4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.59878 8.70254C9.43318 8.70334 9.29958 8.83774 9.29958 9.00334C9.29958 9.16894 9.43398 9.30334 9.59958 9.30254C9.76518 9.30254 9.89958 9.16814 9.89958 9.00254C9.89958 8.83694 9.76518 8.70254 9.59878 8.70254"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.59961 5.80261C5.14601 5.80261 6.39961 7.05621 6.39961 8.60261V13.8026"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BillShieldIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.3158 6.47621V3.10779C15.3158 2.17763 14.5617 1.42358 13.6316 1.42358H2.68421C1.75405 1.42358 1 2.17763 1 3.10779V14.8972C1 15.8274 1.75405 16.5815 2.68421 16.5815H8.57894"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.2632 13.1682V10.9089C10.2611 10.7158 10.4081 10.5536 10.6005 10.5368C11.5338 10.4742 12.4283 10.1401 13.1741 9.57571C13.4454 9.37287 13.8178 9.37287 14.0891 9.57571C14.8349 10.1401 15.7295 10.4742 16.6627 10.5368C16.8551 10.5536 17.0021 10.7158 17 10.9089V13.1682"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.2632 13.213C10.2632 14.8176 12.2629 16.0094 13.1825 16.4727C13.4643 16.6177 13.7989 16.6177 14.0807 16.4727C15.0003 16.0094 17 14.8201 17 13.213"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.36841 5.63406H11.9473" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.36841 9.00247H7.73682" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.36841 12.3709H6.05262" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const CodeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.66669 10.7803L5.88892 9.00251L7.66669 7.22473"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.3334 7.22473L12.1112 9.00251L10.3334 10.7803"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="1"
            y="1.00256"
            width="16"
            height="16"
            rx="4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CreditCartIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 3.66916H14.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.60997 6.78037H3.61108" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1667 11.447H2.83333C1.54456 11.447 0.5 10.4024 0.5 9.11366V2.89144C0.5 1.60266 1.54456 0.558105 2.83333 0.558105H12.1667C13.4554 0.558105 14.5 1.60266 14.5 2.89144V9.11366C14.5 10.4024 13.4554 11.447 12.1667 11.447Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const GitMergeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="14.8947"
            cy="14.4762"
            r="2.10526"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle
            cx="3.10526"
            cy="3.52885"
            r="2.10526"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle
            cx="3.10526"
            cy="14.4762"
            r="2.10526"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.10526 5.63416V12.371" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.74512 5.21302L8.06091 3.52881" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.74512 1.8446L8.06091 3.52882" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M8.06091 3.52881H12.7895C13.9522 3.52881 14.8947 4.47137 14.8947 5.63407V12.3709"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BankCoinsIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.564 13.6341V6.84167" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M2.89493 6.84167V13.6341" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.94754 13.6342H2.0528L1.21069 15.3184V16.1605H7.94754"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3686 4.31035L8.78964 1.00256L1.21069 4.31035V6.84172H16.3686V4.31035V4.31035Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.3678 15.7394L16.3686 10.6868" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.4739 10.6868V15.7394" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M16.3686 10.6867C16.3686 9.98839 15.0482 9.42358 13.4212 9.42358C11.7943 9.42358 10.4747 9.9893 10.4739 10.6867"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.4739 15.7394C10.4739 16.4377 11.7943 17.0025 13.4212 17.0025C15.0482 17.0025 16.3678 16.4368 16.3686 15.7394"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.4739 10.6868C10.4739 11.3851 11.7943 11.9499 13.4212 11.9499C15.0482 11.9499 16.3678 11.3842 16.3686 10.6868"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.4739 13.2131C10.4739 13.9115 11.7943 14.4763 13.4212 14.4763C15.0482 14.4763 16.3678 13.9106 16.3686 13.2131"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BellPointIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.96282 16.5454H6.03711" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.49998 2.83118V2.83118C4.97563 2.83118 2.92855 4.87826 2.92855 7.40261V7.40261V7.43186V9.69198C2.92855 9.98821 2.76123 10.2579 2.497 10.3905L2.03712 10.62C1.46295 10.908 1.09998 11.4949 1.09998 12.1368V12.1368C1.09998 13.073 1.85883 13.8319 2.79506 13.8319H12.2049C13.1411 13.8319 13.9 13.073 13.9 12.1368V12.1368C13.9 11.4949 13.537 10.908 12.9628 10.6209L12.5029 10.3914C12.2387 10.2579 12.0714 9.98821 12.0714 9.69198V7.43186V7.40261V7.40261"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.54137 2.96102C8.20583 2.88239 7.86023 2.83119 7.5 2.83119"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.9415 6.36121C12.0202 6.69675 12.0714 7.04235 12.0714 7.40258"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.0967 1.80593C14.1678 2.87708 14.1678 4.61376 13.0967 5.68491C12.0255 6.75606 10.2888 6.75606 9.21767 5.68491C8.14652 4.61376 8.14652 2.87708 9.21767 1.80593C10.2888 0.734776 12.0255 0.734776 13.0967 1.80593"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SimCartIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8333 13.2248H3.16667C1.69378 13.2248 0.5 12.0311 0.5 10.5582V3.44706C0.5 1.97417 1.69378 0.780396 3.16667 0.780396H13.8333C15.3062 0.780396 16.5 1.97417 16.5 3.44706V10.5582C16.5 12.0311 15.3062 13.2248 13.8333 13.2248Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.73818 8.78035H3.9284C3.50796 8.78035 3.16663 8.43902 3.16663 8.01858V4.2088C3.16663 3.78835 3.50796 3.44702 3.9284 3.44702H7.73818C8.15863 3.44702 8.49996 3.78835 8.49996 4.2088V8.01858C8.49996 8.43902 8.15863 8.78035 7.73818 8.78035Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.16663 6.11376H8.49996" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.83336 6.11369V3.44702" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const CartMasterCartIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.05183 5.11715C10.0931 6.15845 10.0931 7.84672 9.05183 8.88801C8.01053 9.92931 6.32226 9.92931 5.28097 8.88801C4.23968 7.84671 4.23968 6.15844 5.28097 5.11715C6.32227 4.07586 8.01054 4.07586 9.05183 5.11715"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.7191 5.11715C12.7604 6.15845 12.7604 7.84672 11.7191 8.88801C10.6778 9.92931 8.9895 9.92931 7.94821 8.88801C6.90691 7.84671 6.90691 6.15844 7.94821 5.11715C8.9895 4.07586 10.6778 4.07586 11.7191 5.11715"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.1 12.6026H2.9C1.5744 12.6026 0.5 11.5282 0.5 10.2026V3.80259C0.5 2.47699 1.5744 1.40259 2.9 1.40259H14.1C15.4256 1.40259 16.5 2.47699 16.5 3.80259V10.2026C16.5 11.5282 15.4256 12.6026 14.1 12.6026Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const VerifyBadgeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.76152 15.8829C7.02372 15.8483 7.28859 15.9194 7.49746 16.0802L8.46005 16.8188C8.77824 17.0633 9.22087 17.0633 9.53818 16.8188L10.5372 16.0518C10.7239 15.9087 10.9594 15.8456 11.1923 15.8767L12.4419 16.0411C12.8392 16.0936 13.2223 15.8723 13.3761 15.5016L13.8569 14.3391C13.9467 14.1213 14.1191 13.9489 14.3369 13.8591L15.4995 13.3782C15.8701 13.2254 16.0914 12.8414 16.039 12.4441L15.8808 11.2398C15.8461 10.9776 15.9172 10.7127 16.0781 10.5038L16.8167 9.54123C17.0611 9.22303 17.0611 8.7804 16.8167 8.4631L16.0496 7.46407C15.9065 7.27742 15.8434 7.04188 15.8745 6.80901L16.039 5.55934C16.0914 5.16204 15.8701 4.77896 15.4995 4.62519L14.3369 4.14435C14.1191 4.05458 13.9467 3.88215 13.8569 3.66439L13.3761 2.50182C13.2232 2.13118 12.8392 1.90986 12.4419 1.96231L11.1923 2.12674C10.9594 2.15873 10.7239 2.09563 10.5381 1.95342L9.53907 1.18637C9.22087 0.941946 8.77824 0.941946 8.46093 1.18637L7.46191 1.95342C7.27525 2.09563 7.03972 2.15873 6.80685 2.12851L5.55718 1.96408C5.15988 1.91164 4.7768 2.13296 4.62303 2.50359L4.14307 3.66616C4.05241 3.88303 3.87998 4.05546 3.66311 4.14612L2.50054 4.62608C2.12991 4.77985 1.90859 5.16293 1.96103 5.56023L2.12546 6.8099C2.15568 7.04277 2.09258 7.27831 1.95037 7.46407L1.18332 8.4631C0.938894 8.78129 0.938894 9.22392 1.18332 9.54123L1.95037 10.5403C2.09346 10.7269 2.15657 10.9624 2.12546 11.1953L1.96103 12.445C1.90859 12.8423 2.12991 13.2254 2.50054 13.3791L3.66311 13.86C3.88087 13.9498 4.0533 14.1222 4.14307 14.3399L4.62392 15.5025C4.7768 15.8731 5.16076 16.0945 5.55806 16.042L6.76152 15.8829"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.4874 7.75916L8.37563 10.8709L6.51001 9.00438"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeSendIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.1111 3.23462V9.44706" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17 14.7804H11.6666" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.2222 13.0026L16.9999 14.7803L15.2222 16.5581"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.11099 13.0026H2.77766C1.79543 13.0026 0.999878 12.2071 0.999878 11.2248V3.23462"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.78756 1.44702H14.3244C15.3111 1.44702 16.112 2.24702 16.112 3.23458V3.23458C16.112 3.82747 15.8178 4.38124 15.3271 4.71369L10.5653 7.94124C9.352 8.76347 7.75911 8.76347 6.54578 7.94124L1.78489 4.71458C1.29422 4.38213 1 3.82747 1 3.23547V3.23458C1 2.24702 1.8 1.44702 2.78756 1.44702Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopesGoBackIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.4 7.84261H15.24C16.212 7.84261 17 7.05463 17 6.08261V2.56261C17 1.59059 16.212 0.802612 15.24 0.802612H9.95995C8.98793 0.802612 8.19995 1.59059 8.19995 2.56261V5.60261"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.6199 3.44263L12.156 4.21871C12.4357 4.35726 12.7641 4.35726 13.0438 4.21871L14.5799 3.44263"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 9.9226V13.4426C1 14.4146 1.78798 15.2026 2.76 15.2026H8.04C9.01202 15.2026 9.8 14.4146 9.8 13.4426V9.9226C9.8 9.45582 9.61457 9.00815 9.28451 8.67809C8.95444 8.34803 8.50678 8.1626 8.04 8.1626H2.76C1.78798 8.1626 1 8.95058 1 9.9226Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.41992 10.8026L4.95607 11.5787C5.23577 11.7172 5.56413 11.7172 5.84383 11.5787L7.37992 10.8026"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1.40002 3.60264H5.40002" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M3.00002 2.00256L1.40002 3.60256L3.00002 5.20256"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.6 12.4026H12.6" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15 14.0026L16.6 12.4026L15 10.8026"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EtiquetteIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.56851 2.13499L0.831699 5.96706C0.388783 6.58643 0.388783 7.41968 0.831699 8.03905L3.56851 11.8711C3.9027 12.339 4.44275 12.617 5.01846 12.617H14.7172C15.7019 12.617 16.4995 11.8194 16.4995 10.8347V3.17054C16.4995 2.18579 15.7019 1.38818 14.7172 1.38818H5.01846C4.44275 1.38818 3.9027 1.66623 3.56851 2.13499Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.20691 5.86827C7.83336 6.49472 7.83336 7.5104 7.20691 8.13684C6.58046 8.76329 5.56479 8.76329 4.93834 8.13684C4.31189 7.51039 4.31189 6.49472 4.93834 5.86827C5.56479 5.24183 6.58046 5.24183 7.20691 5.86827"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FileMagicIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        {...props}
        width={props.width || "17"}
        height={props.height || "18"}
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.49965 17.0026C4.49965 15.0389 2.90777 13.447 0.944092 13.447C2.90777 13.447 4.49965 11.8552 4.49965 9.89148C4.49965 11.8552 6.09152 13.447 8.0552 13.447C6.09152 13.447 4.49965 15.0389 4.49965 17.0026Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.7219 17.0026H13.833C15.0603 17.0026 16.0553 16.0076 16.0553 14.7803V5.77738C16.0553 5.07014 15.7743 4.39186 15.2742 3.89176L13.1661 1.78361C12.666 1.28352 11.9877 1.00256 11.2804 1.00256H4.94415C3.71685 1.00256 2.72192 1.99749 2.72192 3.22479V6.3359"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.0342 5.44701H12.9441C12.2077 5.44701 11.6107 4.85005 11.6107 4.11368V1.02356"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AttachmentIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.17011 5.78112L4.294 10.6572C3.55983 11.3914 3.55983 12.5824 4.294 13.3166V13.3166C5.02817 14.0508 6.2192 14.0508 6.95337 13.3166L13.3814 6.8886C14.7279 5.54203 14.7279 3.35907 13.3814 2.01249V2.01249C12.0348 0.66592 9.85184 0.66592 8.50526 2.01249L2.07726 8.44049C0.118288 10.3995 0.118288 13.5744 2.07726 15.5333V15.5333C4.03624 17.4923 7.21113 17.4923 9.17011 15.5333L13.0712 11.6323"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FileStopIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.8889 8.11367V5.29412C13.8889 4.82301 13.7013 4.37056 13.368 4.03723L10.8542 1.52345C10.5209 1.19012 10.0685 1.00256 9.59735 1.00256H3.22224C2.24001 1.00256 1.44446 1.79812 1.44446 2.78034V15.2248C1.44446 16.207 2.24001 17.0026 3.22224 17.0026H8.55557"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.8889 5.44701H10.3333C9.84268 5.44701 9.44446 5.04878 9.44446 4.55812V1.00256"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5556 13.8915C16.5556 15.6133 15.1663 17.0026 13.4445 17.0026C11.7227 17.0026 10.3334 15.6133 10.3334 13.8915C10.3334 12.1697 11.7227 10.7804 13.4445 10.7804C15.1663 10.7804 16.5556 12.1697 16.5556 13.8915Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M11.2452 16.0905L15.6435 11.6923" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const RefreshIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.33333 5.66927H1V2.33594" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M17.0002 9.00256C17.0002 4.5839 13.4188 1.00256 9.00015 1.00256C5.77349 1.00256 2.99926 2.91723 1.73438 5.66923"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.6666 12.3359H17V15.6693" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M1 9.00256C1 13.4212 4.58133 17.0026 9 17.0026C12.2267 17.0026 15.0009 15.0879 16.2658 12.3359"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StopIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.657 3.3457L3.34326 14.6595L14.657 3.3457Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 1.00256V1.00256C4.58133 1.00256 1 4.5839 1 9.00256V9.00256C1 13.4212 4.58133 17.0026 9 17.0026V17.0026C13.4187 17.0026 17 13.4212 17 9.00256V9.00256C17 4.5839 13.4187 1.00256 9 1.00256Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const NetworkDocumentIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1081 2.90959H8.45747C8.1712 2.90959 7.90309 2.76776 7.74223 2.53078L6.95953 1.38051C6.79866 1.1444 6.53142 1.00256 6.24515 1.00256H3.89184C2.93617 1.00256 2.16211 1.77662 2.16211 2.7323V9.65123C2.16211 10.6069 2.93617 11.381 3.89184 11.381H12.1081C13.0638 11.381 13.8378 10.6069 13.8378 9.65123V4.63933C13.8378 3.68452 13.0638 2.90959 12.1081 2.90959Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.99994 11.3983V14.4081" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.29724 15.7053H14.9189" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.08105 15.7053H6.70269" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M8.91727 14.7879C9.42389 15.2946 9.42389 16.116 8.91727 16.6226C8.41064 17.1292 7.58924 17.1292 7.08261 16.6226C6.57598 16.116 6.57598 15.2946 7.08261 14.7879C7.58923 14.2813 8.41064 14.2813 8.91727 14.7879"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CopyDashIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.36795 14.4762V14.0551" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.36791 11.7394L4.36799 11.3183" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.36795 9.00255V8.5815" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="13.6311"
            y="16.5814"
            width="12.6316"
            height="10.1053"
            rx="2.5"
            transform="rotate(-180 13.6311 16.5814)"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.6311 11.5288H14.8942C16.0569 11.5288 16.9995 10.5863 16.9995 9.42358V3.52885C16.9995 2.36614 16.0569 1.42358 14.8942 1.42358H6.47318C5.31048 1.42358 4.36792 2.36614 4.36792 3.52885V6.47622"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ApiIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.22803 9.88267H7.00183" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.23951 10.6026L6.07311 7.00256H5.16591L3.99951 10.6026"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.19946 7.00256H10.5995C11.1517 7.00256 11.5995 7.45028 11.5995 8.00256V8.00256C11.5995 8.26778 11.4941 8.52213 11.3066 8.70967C11.119 8.89721 10.8647 9.00256 10.5995 9.00256H9.19946V7.00256Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.19956 7.00256V10.6026" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.5995 7.00256V10.6026" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="0.999512"
            y="1.00256"
            width="16"
            height="16"
            rx="5.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BuildingFlagIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.79966 10.8024V16.4024" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.99949 10.8024V16.4024" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.1997 10.8024V16.4024" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.9995 16.4026H0.999512" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M8.99963 5.20251V1.60251C8.99963 1.3816 9.17872 1.20251 9.39963 1.20251H11.7996C12.0205 1.20251 12.1996 1.3816 12.1996 1.60251V2.73691C12.1996 2.95783 12.0205 3.13691 11.7996 3.13691H8.99963"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.79944 7.60264V6.33384C5.79944 6.12168 5.8838 5.91823 6.03384 5.76824L6.36504 5.43704C6.51503 5.287 6.71848 5.20268 6.93064 5.20264H11.0682C11.2804 5.20268 11.4838 5.287 11.6338 5.43704L11.965 5.76824C12.1151 5.91823 12.1994 6.12168 12.1994 6.33384V7.60264"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M2.59961 10.8026H15.3996" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M15.3996 16.4025V8.73374C15.3996 8.52158 15.3152 8.31813 15.1652 8.16814L14.834 7.83694C14.684 7.6869 14.4806 7.60254 14.2684 7.60254H3.73081C3.51865 7.60254 3.3152 7.6869 3.16521 7.83694L2.83401 8.16814C2.68397 8.31813 2.59961 8.52158 2.59961 8.73374V16.4025"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ChronometerIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.2314 5.79685C14.7947 8.36013 14.7947 12.5169 12.2314 15.0801C9.6681 17.6434 5.51138 17.6434 2.9481 15.0801C0.384814 12.5169 0.384814 8.36013 2.9481 5.79685C5.51138 3.23357 9.6681 3.23357 12.2314 5.79685"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.99996 10.4368C7.99996 10.2104 7.81616 10.0274 7.5897 10.0282C7.36324 10.029 7.17944 10.2128 7.17944 10.4393C7.17944 10.6657 7.36242 10.8487 7.58888 10.8487C7.81534 10.8487 7.99914 10.6649 7.99996 10.4376"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.5897 7.15637V10.4384" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.94873 1.41282H9.23078" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M14.9745 4.69486L13.3335 3.05383L14.154 3.87435L12.2316 5.79681"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const RefreshBuildingIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.7142 7.43265L15.8571 6.28979L16.9999 7.43265"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.28571 8.57556L2.14286 9.71842L1 8.57556"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.71433 10.6707V7.18115" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.99997 10.6707V7.18115" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.2857 10.6707V7.18115" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.95239 10.6707H12.0476" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.95239 5.8228V7.18128H12.0476V5.8228L9.00001 4.57556L5.95239 5.8228Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.31577 9.51878C2.20606 9.03116 2.14282 8.52526 2.14282 8.00412C2.14282 4.21745 5.2133 1.14697 8.99997 1.14697C11.3047 1.14697 13.3352 2.29059 14.5786 4.03459"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.6873 6.48645C15.797 6.97407 15.8602 7.47997 15.8602 8.00112C15.8602 11.7878 12.7898 14.8583 9.00311 14.8583C6.69758 14.8583 4.66711 13.7146 3.42444 11.9706"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const NetworkCloudIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
            cx="8.00006"
            cy="15.7053"
            r="1.2973"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.32436 11.381C2.29434 11.381 0.648682 9.73534 0.648682 7.70532"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.3243 5.3269C13.9961 5.3269 15.3514 6.68215 15.3514 8.35393C15.3514 10.0257 13.9961 11.381 12.3243 11.381"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.99915 1.00256C9.14603 1.00256 10.2459 1.45816 11.0569 2.26913C11.8679 3.0801 12.3235 4.18001 12.3235 5.32689"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.29736 15.7053H14.919" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.08105 15.7053H6.70268" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.00006 11.3983V14.408" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M3.88105 4.07434C2.0401 4.29248 0.652249 5.85147 0.648682 7.7053"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.99917 1.00256C6.0995 1.00703 4.42676 2.25472 3.88098 4.0743"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12.3243 11.3809H4.32434" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const EnvelopeCheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.4001 8.60912V2.42908" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.82245 12.0027H3.40001C2.07441 12.0027 1 10.9283 1 9.60272V2.42908"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.70884 6.41717L1.86801 3.86755C1.3344 3.58595 1 3.03235 1 2.42914V2.40274C1 1.51874 1.716 0.802734 2.60001 0.802734H13.7737C14.6721 0.802734 15.4001 1.53074 15.4001 2.42914V2.44514C15.4001 3.03875 15.0713 3.58435 14.5457 3.86115L9.69125 6.41797C8.75765 6.90917 7.64244 6.90917 6.70884 6.41717Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.8001 10.9244L13.0497 12.6748L12.0001 11.6244"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.9455 9.06037C17.3511 10.47 17.3511 12.7564 15.9463 14.1668C14.5703 15.5476 12.2303 15.5476 10.8535 14.1668C9.44788 12.7564 9.44868 10.47 10.8543 9.06037C12.2599 7.64996 14.5399 7.64996 15.9455 9.06037"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const IdentityCartIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="0.5"
            y="1.00256"
            width="16"
            height="16"
            rx="3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="4.05554"
            y="4.55811"
            width="3.55556"
            height="3.55556"
            rx="1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.05554 10.7804H12.9444" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.05554 13.447H10.2778" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const TextUnderlineIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 1.25256V7.25256C10 9.4617 8.20914 11.2526 6 11.2526V11.2526C3.79086 11.2526 2 9.4617 2 7.25256V1.25256"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1 14.2526H11" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const TextCrossedOutIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4 13.0026H10C11.6569 13.0026 13 11.6594 13 10.0026V10.0026"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M15 7.00256H1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M12 1.00256H7C5.34315 1.00256 4 2.34571 4 4.00256V4.00256"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TextBoldIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 1.00256H6.875C8.53185 1.00256 9.875 2.34571 9.875 4.00256V4.00256C9.875 5.65942 8.53185 7.00256 6.875 7.00256H1V1.00256Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1 7.00256H8C9.65685 7.00256 11 8.34571 11 10.0026V10.0026C11 11.6594 9.65685 13.0026 8 13.0026H1V7.00256Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CodeCloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.4242 0.602539L7.57617 13.4025"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.8 3.80249L17 7.00249L13.8 10.2025"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.2 10.2025L1 7.00249L4.2 3.80249"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ColorPaletteIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.99884 4.00237C8.86373 4.00237 8.75439 4.11171 8.75617 4.24682C8.75617 4.38194 8.8655 4.49127 9.00062 4.49127C9.13573 4.49127 9.24507 4.38194 9.24507 4.24682C9.24329 4.11171 9.13484 4.00237 8.99884 4.00237"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.48753 9.0014C4.48753 8.86629 4.3782 8.75695 4.24397 8.75873C4.10886 8.75873 3.99952 8.86807 3.99952 9.00318C3.99952 9.1383 4.10886 9.24763 4.24397 9.24763C4.37909 9.24763 4.48753 9.13741 4.48753 9.0014"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.5351 5.46621C12.44 5.3711 12.2854 5.3711 12.1911 5.4671C12.096 5.56221 12.096 5.71688 12.1911 5.812C12.2862 5.90711 12.4409 5.90711 12.536 5.812C12.6311 5.71599 12.6311 5.56221 12.5351 5.46621"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.80845 12.1928C5.71334 12.0977 5.55867 12.0977 5.46445 12.1937C5.36933 12.2888 5.36933 12.4434 5.46445 12.5386C5.55956 12.6337 5.71423 12.6337 5.80934 12.5386C5.90446 12.4434 5.90446 12.2888 5.80845 12.1928"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.8093 5.81126C5.90441 5.71615 5.90441 5.56148 5.80841 5.46725C5.7133 5.37214 5.55863 5.37214 5.46351 5.46725C5.3684 5.56237 5.3684 5.71704 5.46351 5.81215C5.55863 5.90726 5.7133 5.90726 5.8093 5.81126"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.9998 17.0026C4.50635 17.0026 0.877816 13.2976 1.00315 8.77569C1.11871 4.60136 4.5988 1.12127 8.77313 1.00572C13.295 0.880379 17 4.50892 17 9.00236V9.89127C17 10.8735 16.2044 11.6691 15.2222 11.6691H13.3884C12.207 11.6691 11.3545 12.7998 11.679 13.9349L11.9074 14.7358C12.2328 15.8719 11.3794 17.0026 10.1989 17.0026H8.9998Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CreditCartCheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13 15.2026C10.7912 15.2026 9 13.4122 9 11.2034C9 9.03944 10.84 7.20104 13.004 7.20264C15.2112 7.20424 17 8.99464 17 11.2026C17 13.4114 15.2096 15.2026 13 15.2026"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1 3.88267H16.2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M16.2 8.80261V2.40261C16.2 1.51861 15.484 0.802612 14.6 0.802612H2.6C1.716 0.802612 1 1.51861 1 2.40261V9.60261C1 10.4866 1.716 11.2026 2.6 11.2026H9"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.7775 10.3137L12.5551 12.5361L11.2223 11.2025"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AttachmentAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.00008 14.7803L7.51423 16.2662C7.04273 16.7377 6.40325 17.0026 5.73645 17.0026C5.06965 17.0026 4.43017 16.7377 3.95867 16.2662V16.2662C3.48717 15.7947 3.22229 15.1552 3.22229 14.4884C3.22229 13.8216 3.48717 13.1821 3.95867 12.7106L11.2223 5.44702"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.2669 8.51341V8.51341C16.9852 6.79521 16.9852 4.00945 15.2669 2.29124V2.29124C14.4418 1.46612 13.3227 1.00256 12.1558 1.00256C10.9889 1.00256 9.86984 1.46612 9.04473 2.29124L1.44446 9.89146"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10.3334 11.6693H13.8889" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.1111 9.89148V13.447" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const FileEditIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.57898 9.00247H11.1053" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.57893 5.63407H4.36841" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.7894 5.63407H11.1052" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.36841 9.00247H6.05262" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.36841 12.371H8.57893" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8783 16.3348L16.7533 13.4598C17.0822 13.1309 17.0822 12.5978 16.7533 12.2689L15.4178 10.9334C15.089 10.6046 14.5558 10.6046 14.2269 10.9334L11.3519 13.8084C11.1939 13.9664 11.1052 14.1806 11.1052 14.4039V16.1604C11.1052 16.393 11.2937 16.5815 11.5263 16.5815H13.2828C13.5062 16.5815 13.7203 16.4928 13.8783 16.3348Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.1579 8.16042V3.9499C16.1579 2.55465 15.0268 1.42358 13.6316 1.42358H3.52631C2.13107 1.42358 1 2.55465 1 3.9499V14.0552C1 15.4504 2.13107 16.5815 3.52631 16.5815H7.73684"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FavoriteSearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.0001 13.9191L14.4969 11.416" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M11.6664 4.61243C13.8602 4.61243 15.6389 6.39109 15.6389 8.58487C15.6389 10.7786 13.8602 12.5582 11.6664 12.5582C9.47264 12.5582 7.69397 10.7795 7.69397 8.58576C7.69397 6.39198 9.47264 4.61243 11.6664 4.61243"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.6667 12.5581V17.0026L6.34044 14.3359L1 17.0026V2.78034C1 1.79812 1.79556 1.00256 2.77778 1.00256H9.88889C10.8711 1.00256 11.6667 1.79812 11.6667 2.78034V4.61234"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UserCirclePassWordIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.42102 14.4762L3.94734 17.0025" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.42102 17.0025L3.94734 14.4762" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.73682 14.4762L10.2631 17.0025" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.73682 17.0025L10.2631 14.4762" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.0526 14.4762L16.5789 17.0025" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.0526 17.0025L16.5789 14.4762" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M11.9033 10.1866C11.5657 9.26533 10.4052 8.58154 8.99977 8.58154C7.5943 8.58154 6.43388 9.26533 6.09619 10.1866"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.5728 2.48245C14.5459 4.45563 14.5459 7.65478 12.5728 9.62795C10.5996 11.6011 7.40044 11.6011 5.42727 9.62795C3.45409 7.65477 3.45409 4.45562 5.42727 2.48245C7.40045 0.509269 10.5996 0.509269 12.5728 2.48245"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.1909 3.81165C10.8487 4.46938 10.8487 5.53576 10.1909 6.19349C9.5332 6.85121 8.46682 6.85121 7.80909 6.19349C7.15136 5.53576 7.15136 4.46938 7.80909 3.81165C8.46682 3.15393 9.5332 3.15393 10.1909 3.81165"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const MandatorySquareIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5.93408 7.22835L9.02119 9.01058V5.44702"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.94141 10.7893L9.02141 9.01062V12.5582"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.0772 7.24609L9.02124 9.01054L12.071 10.7714"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.3333 17.0026H3.66667C2.19378 17.0026 1 15.8088 1 14.3359V3.66923C1 2.19634 2.19378 1.00256 3.66667 1.00256H14.3333C15.8062 1.00256 17 2.19634 17 3.66923V14.3359C17 15.8088 15.8062 17.0026 14.3333 17.0026Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const JsonCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M5 13.4025C3.89543 13.4025 3 12.5071 3 11.4025V9.00254C3 8.47211 2.78929 7.9634 2.41421 7.58833C2.03914 7.21325 1.53043 7.00254 1 7.00254C1.53043 7.00254 2.03914 6.79183 2.41421 6.41675C2.78929 6.04168 3 5.53297 3 5.00254V2.60254C3 1.49797 3.89543 0.602539 5 0.602539"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13 0.602539C14.1046 0.602539 15 1.49797 15 2.60254V5.00254C15 6.10711 15.8954 7.00254 17 7.00254C15.8954 7.00254 15 7.89797 15 9.00254V11.4025C15 12.5071 14.1046 13.4025 13 13.4025"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.60002 8.00249L7.40002 6.80249" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.6 6.00256L8.59998 8.00256" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const BinarySquareIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.55556 1.00256H13.4444C15.4081 1.00256 17 2.59444 17 4.55812V13.447C17 15.4107 15.4081 17.0026 13.4444 17.0026H4.55556C2.59188 17.0026 1 15.4107 1 13.447V4.55812C1 2.59444 2.59188 1.00256 4.55556 1.00256Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M10.4076 7.6693H12.778" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.4076 4.55809H11.5928" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.5925 4.55811V7.66922" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="5.22217"
            y="4.55811"
            width="2.96296"
            height="3.11111"
            rx="0.66667"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.22217 13.447H7.59254" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.22217 10.3359H6.40735" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.40721 10.3359V13.447" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="9.81494"
            y="10.3359"
            width="2.96296"
            height="3.11111"
            rx="0.66667"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeEditIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.41894 12.7593H3.0946C1.66164 12.7593 0.5 11.5976 0.5 10.1647V3.24572C0.5 1.81277 1.66164 0.651123 3.0946 0.651123H13.473C14.906 0.651123 16.0676 1.81277 16.0676 3.24572V6.70519"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.0339 2.91293L9.60996 6.66542C8.80143 7.13773 7.80113 7.13773 6.9926 6.66542L0.5354 2.89355"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.692 15.1158L16.2466 11.5612C16.5843 11.2235 16.5843 10.676 16.2466 10.3383L15.0291 9.1207C14.8669 8.95853 14.647 8.86743 14.4176 8.86743C14.1883 8.86743 13.9684 8.95853 13.8062 9.1207L10.2516 12.6754C10.0991 12.8278 10.0134 13.0346 10.0134 13.2503V14.9216C10.0134 15.0363 10.059 15.1463 10.1401 15.2273C10.2211 15.3084 10.3311 15.354 10.4458 15.354H12.1171C12.3327 15.354 12.5395 15.2683 12.692 15.1158V15.1158Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BadgeUserIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M9.09998 3.40234H12.3C13.184 3.40234 13.9 4.11834 13.9 5.00234V15.4023C13.9 16.2863 13.184 17.0023 12.3 17.0023H2.69998C1.81598 17.0023 1.09998 16.2863 1.09998 15.4023V5.00234C1.09998 4.11834 1.81598 3.40234 2.69998 3.40234H5.89998"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.77274 7.92955C9.47569 8.6325 9.47569 9.77219 8.77274 10.4751C8.0698 11.1781 6.9301 11.1781 6.22716 10.4751C5.52422 9.77219 5.52422 8.6325 6.22716 7.92955C6.9301 7.22661 8.0698 7.22661 8.77274 7.92955"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.3758 14.6024C10.2358 14.2512 10.0198 13.936 9.74218 13.6792V13.6792C9.27258 13.244 8.65658 13.0024 8.01658 13.0024H6.98298C6.34298 13.0024 5.72698 13.244 5.25738 13.6792V13.6792C4.97978 13.936 4.76378 14.2512 4.62378 14.6024"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.30002 5.00244H6.70002C6.25842 5.00244 5.90002 4.64404 5.90002 4.20244V1.80244C5.90002 1.36084 6.25842 1.00244 6.70002 1.00244H8.30002C8.74162 1.00244 9.10002 1.36084 9.10002 1.80244V4.20244C9.10002 4.64404 8.74162 5.00244 8.30002 5.00244Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CreditCartProcessingIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.5 5.00231H16.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.27764 8.55797H4.05542" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M16.4989 13.0025C16.4991 14.9659 14.9076 16.5578 12.9442 16.558C10.9921 16.5292 9.41669 14.9537 9.38782 13.0017C9.38804 11.038 10.9801 9.44631 12.9438 9.44653C14.9074 9.44675 16.4991 11.0388 16.4989 13.0025"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8503 11.6702V13.2133L14.064 13.9536"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.72222 13.8912H3.16667C1.69391 13.8912 0.5 12.6973 0.5 11.2246V4.11344C0.5 2.64068 1.69391 1.44678 3.16667 1.44678H13.8333C15.3061 1.44678 16.5 2.64068 16.5 4.11344V7.669"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ShieldKeyIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.1115 8.32781C15.1115 12.2105 12.3052 15.8497 8.46248 16.9377C8.16203 17.023 7.83847 17.023 7.53802 16.9377C3.6953 15.8506 0.889038 12.2105 0.889038 8.32781V4.74732C0.889038 4.02553 1.32549 3.37485 1.99394 3.10196L6.31756 1.33305C7.39668 0.891263 8.60559 0.891263 9.68383 1.33305L14.0074 3.10196C14.675 3.37485 15.1115 4.02553 15.1115 4.74732V8.32781Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.3673 8.9348C9.75486 8.50012 9.93797 7.88056 9.76464 7.22366C9.60375 6.6121 9.10241 6.11342 8.49084 5.95431C7.2686 5.63608 6.16992 6.54987 6.16992 7.72056C6.16992 8.18723 6.34504 8.61212 6.63215 8.9348C6.83838 9.16591 6.92193 9.47969 6.83749 9.77747L6.49437 10.9802C6.3317 11.5482 6.75837 12.1135 7.34949 12.1135H8.65262C9.24285 12.1135 9.66953 11.5482 9.50775 10.9802L9.16463 9.77747C9.07752 9.47969 9.16196 9.16591 9.3673 8.9348V8.9348Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UserErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9.3656" cy="5.25171" r="4.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M1.36572 17.0017C1.36572 14.5167 3.38072 12.5017 5.86572 12.5017H8.44873"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.0977 16.7696L16.6337 13.2336" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.0977 13.2336L16.6337 16.7696" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const BadgeCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.97754 9.89049L5.86643 10.7794L7.19976 9.44604"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.333 15.2239C11.333 16.2058 10.5371 17.0017 9.55527 17.0017H2.44416C1.46232 17.0017 0.666382 16.2058 0.666382 15.2239V2.77949C0.666382 1.79765 1.46232 1.00171 2.44416 1.00171H9.55527C10.5371 1.00171 11.333 1.79765 11.333 2.77949V15.2239"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.22191 1.00171V2.77949C8.22191 3.02495 8.02293 3.22393 7.77747 3.22393H4.22191C3.97645 3.22393 3.77747 3.02495 3.77747 2.77949V1.00171"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopePostedIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.4647 2.96316V2.96316C11.8107 3.30911 11.8971 3.74154 11.8107 4.08749L10.8593 9.1037C10.5999 10.3145 9.6485 11.2659 8.43769 11.5253L3.42147 12.4767C2.98904 12.5632 2.55661 12.3902 2.29715 12.1307V12.1307C1.77823 11.6118 1.77823 10.8334 2.29715 10.3145L9.6485 2.96316C10.0809 2.44424 10.9458 2.44424 11.4647 2.96316V2.96316Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.62164 0.714445C6.59743 0.714445 6.5784 0.695418 6.5784 0.671202C6.5784 0.646986 6.59743 0.627959 6.62164 0.627959C6.64586 0.627959 6.66488 0.646986 6.66488 0.671202C6.66488 0.695418 6.64586 0.714445 6.62164 0.714445"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M1.43237 15.3306H16.9999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.43243 3.22252V0.62793" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.02704 1.49279V0.62793" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M11.4649 2.96289L15.9622 7.46019C16.6541 8.15208 16.6541 9.18992 15.9622 9.88181L10.5135 15.3305"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M2.21069 12.2173L5.41069 15.3308" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const PostIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.7838 17.0009V4.46038C16.7838 2.7886 15.4285 1.43335 13.7568 1.43335V1.43335C12.085 1.43335 10.7297 2.7886 10.7297 4.46038V17.0009"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.67565 1.43335V1.43335C2.76504 1.43335 1.21619 2.9822 1.21619 4.89281V17.0009"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.67566 1.43341H13.3243" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.7838 16.136H1.21619" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="3.81079"
            y="10.082"
            width="4.32432"
            height="2.59459"
            rx="0.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.24316 7.48736H7.70262" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const EnvelopeHandIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 9.60103L3.04043 6.20031C3.27527 5.80892 3.61684 5.4926 4.0251 5.28847L4.49325 5.0544C4.8265 4.88778 5.19397 4.80103 5.56656 4.80103H6.6"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.57603 8.62503C6.97642 8.33749 6.59635 7.73 6.6 7.06503V2.40103C6.6 1.51737 7.31637 0.801025 8.20003 0.801025H15.4C16.2837 0.801025 17 1.51737 17 2.40103V7.20103C17 8.08468 16.2837 8.80103 15.4 8.80103H11.1186"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.61719 2.22959L10.5208 4.48027C11.2628 4.90805 12.1765 4.90805 12.9184 4.48027L16.9738 2.14209"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.6001 15.201L7.20959 13.5354C7.85296 13.3029 8.40489 12.8704 8.78443 12.3012L11.1787 8.71088C11.527 8.18868 11.4582 7.49327 11.0143 7.04944V7.04944C10.5002 6.53535 9.66676 6.53527 9.15257 7.04925L7.4001 8.80098H5.8001"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FavoriteIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.6778 1.00098H10.3222C11.3045 1.00098 12.1 1.79653 12.1 2.77875V17.001L6.50714 14.0916L0.900024 17.001V2.77875C0.900024 1.79653 1.69558 1.00098 2.6778 1.00098Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FavoriteBarIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.6778 1.00098H10.3222C11.3045 1.00098 12.1 1.79653 12.1 2.77875V17.001L6.50714 14.0916L0.900024 17.001V2.77875C0.900024 1.79653 1.69558 1.00098 2.6778 1.00098Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.72205 7.22325H8.2776" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ColumnIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.27778 1.00098H14.7222C15.7044 1.00098 16.5 1.79653 16.5 2.77875V15.2232C16.5 16.2054 15.7044 17.001 14.7222 17.001H2.27778C1.29556 17.001 0.5 16.2054 0.5 15.2232V2.77875C0.5 1.79653 1.29556 1.00098 2.27778 1.00098Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.83336 1.00098V17.001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.1666 1.00098V17.001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const FavoriteAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.6778 1.00098H10.3222C11.3045 1.00098 12.1 1.79653 12.1 2.77875V17.001L6.50714 14.0916L0.900024 17.001V2.77875C0.900024 1.79653 1.69558 1.00098 2.6778 1.00098Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.72205 7.22325H8.2776" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.49986 5.44531V9.00087" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const CopyIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
            x="3.1665"
            y="3.66748"
            width="9.33356"
            height="9.33356"
            rx="2"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.16673 10.3343H1.83336C1.09697 10.3343 0.5 9.73732 0.5 9.00092V2.3341C0.5 1.5977 1.09697 1.00073 1.83336 1.00073H8.50019C9.23659 1.00073 9.83356 1.5977 9.83356 2.3341V3.66746"
            stroke="currentColor"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const WinDowsIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.4298 16.5317L1.98533 14.4579C1.12844 14.3148 0.5 13.5735 0.5 12.7042V5.29795C0.5 4.42861 1.12844 3.68728 1.98533 3.54417L14.4298 1.47039C15.5133 1.28995 16.5 2.1255 16.5 3.22328V14.7788C16.5 15.8766 15.5133 16.7122 14.4298 16.5317Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M7.16661 2.68115V15.3212" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.5 8.87657H16.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ArrowRightIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.5 9.00098L4.5 5.00098L0.5 1.00098"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const UserSearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.970581 16.0598C0.970581 13.7068 2.85293 11.8245 5.20587 11.8245H7.65293"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.3235 2.13039C12.9235 3.73039 12.9235 6.27156 11.3235 7.77745C9.72351 9.28333 7.18233 9.37745 5.67645 7.77745C4.17057 6.17745 4.07645 3.63627 5.67645 2.13039C7.27645 0.624506 9.72351 0.624506 11.3235 2.13039"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.5233 12.107C15.4645 13.0482 15.4645 14.5541 14.5233 15.4952C13.5821 16.4364 12.0763 16.4364 11.1351 15.4952C10.1939 14.5541 10.1939 13.0482 11.1351 12.107C12.0763 11.1658 13.5821 11.1658 14.5233 12.107"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.0293 17.001L14.5234 15.4951" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.5 1.00098L0.5 9.00275L8.49556 17.001"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StorageIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8333 9.77881H3.16667C1.69378 9.77881 0.5 10.9726 0.5 12.4455V12.4455C0.5 13.9184 1.69378 15.1121 3.16667 15.1121H13.8333C15.3062 15.1121 16.5 13.9184 16.5 12.4455V12.4455C16.5 10.9726 15.3062 9.77881 13.8333 9.77881Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.8333 12.4454H7.61108" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M3.19804 12.414C3.2154 12.4314 3.2154 12.4595 3.19804 12.4768C3.18068 12.4942 3.15254 12.4942 3.13519 12.4768C3.11783 12.4595 3.11783 12.4314 3.13519 12.414C3.15254 12.3966 3.18068 12.3966 3.19804 12.414"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.4909 12.2294L15.738 2.52989C15.666 1.60456 14.8944 0.889893 13.9656 0.889893H3.034C2.10511 0.889893 1.33356 1.60456 1.26156 2.52989L0.508667 12.2294"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ArrowDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.5 1.00098L4.5 5.00098L8.5 1.00098"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BuildingsIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.1364 14.3646V2.00095C12.1364 1.5995 11.8106 1.27368 11.4091 1.27368H5.59092C5.18947 1.27368 4.86365 1.5995 4.86365 2.00095V14.3646"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.86366 5.63721H1.95457C1.55311 5.63721 1.22729 5.96303 1.22729 6.36448V14.3645"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.7727 14.3645V6.36448C15.7727 5.96303 15.4469 5.63721 15.0454 5.63721H12.1364"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.68176 11.4554H10.3181" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.59093 11.4556V14.3647" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.40905 14.3647V11.4556" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.04541 6.72814H9.9545" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.04541 8.91002H9.9545" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.04541 4.5465H9.9545" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.40906 8.91002H4.8636" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M3.40906 11.4554H4.8636" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.1364 8.91002H13.5909" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.1364 11.4554H13.5909" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.5 14.3646H0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const KeyIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.0676 5.00104H7.53137" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.0677 8.01071V5.00098" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.6082 8.01071V5.00098" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M6.50176 2.51507C7.87471 3.88802 7.87471 6.11403 6.50176 7.48699C5.1288 8.85994 2.90279 8.85994 1.52984 7.48699C0.156883 6.11403 0.156883 3.88802 1.52984 2.51507C2.90279 1.14211 5.1288 1.14211 6.50176 2.51507"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StatisticIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.8053 1.00993C13.5054 1.41601 15.6404 3.55019 16.0456 6.25024C16.1198 6.74363 15.7227 7.18595 15.2236 7.18595H10.6925C10.2378 7.18595 9.86877 6.81694 9.86877 6.36227V1.83115C9.86877 1.33199 10.3119 0.935797 10.8053 1.00993V1.00993Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.8941 13.5745C15.4863 12.7747 15.8916 11.8283 16.0456 10.7995C16.1198 10.3061 15.7227 9.86377 15.2236 9.86377H11.8572C11.1233 9.86377 10.7559 10.7509 11.2748 11.2698L13.6561 13.6511C14.007 14.0012 14.5984 13.9732 14.8941 13.5745V13.5745Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.26606 4.5774C2.86175 5.08315 0.353615 8.3359 1.06775 12.0087C1.54302 14.4526 3.51823 16.4188 5.96377 16.8842C7.81789 17.2367 9.56247 16.7697 10.8993 15.7821C11.2996 15.4864 11.3301 14.8933 10.9784 14.5416L7.43323 10.9964C7.27838 10.8416 7.19189 10.6323 7.19189 10.4141V5.3978C7.19189 4.90276 6.75616 4.50492 6.26606 4.5774V4.5774Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopesIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.31079 4.02789H13.6892" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7366 6.62256H2.26355C1.40907 6.62256 0.716309 7.31532 0.716309 8.1698V8.1698C0.716309 8.68267 0.970579 9.16267 1.39523 9.45067L6.54723 12.9421C7.7269 13.7413 9.27415 13.7413 10.4538 12.9421L15.6041 9.45153C16.0296 9.16353 16.2839 8.68353 16.2839 8.17067V8.1698C16.2839 7.31532 15.5911 6.62256 14.7366 6.62256V6.62256Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.4471 12.272L1.22656 16.4925" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.5531 12.272L15.7736 16.4925" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M0.716309 8.18384V15.2714C0.716309 16.2271 1.49036 17.0011 2.44604 17.0011H14.5541C15.5098 17.0011 16.2839 16.2271 16.2839 15.2714V8.18384"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M5.04041 1.43341H11.9593" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const UserSquaresIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3514 17.0011H1.98166C1.16299 17.0011 0.499878 16.3379 0.499878 15.5193V5.1495C0.499878 4.33084 1.16299 3.66772 1.98166 3.66772H12.3523C13.1701 3.66772 13.8332 4.33084 13.8332 5.1495V15.5202C13.8332 16.3379 13.1701 17.0011 12.3514 17.0011Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.73784 7.37073C9.60539 8.23828 9.60539 9.64539 8.73784 10.5138C7.87028 11.3814 6.46317 11.3814 5.59473 10.5138C4.72628 9.64628 4.72717 8.23917 5.59473 7.37073C6.46228 6.50228 7.86939 6.50317 8.73784 7.37073"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.1667 14.7201C11.0503 14.4276 10.8699 14.1645 10.6387 13.9503V13.9503C10.2485 13.5876 9.73741 13.3867 9.20408 13.3867C8.31519 13.3867 6.0183 13.3867 5.12941 13.3867C4.59608 13.3867 4.08586 13.5885 3.69475 13.9503V13.9503C3.46364 14.1645 3.28319 14.4276 3.16675 14.7201"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.16675 3.66764V2.48275C3.16675 1.66409 3.82986 1.00098 4.64853 1.00098H15.0192C15.837 1.00098 16.5001 1.66409 16.5001 2.48275V12.8534C16.5001 13.6712 15.837 14.3343 15.0183 14.3343H13.8334"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const MenuIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7222 17.001H12.0555C11.0733 17.001 10.2777 16.2054 10.2777 15.2232V10.7788C10.2777 9.79653 11.0733 9.00098 12.0555 9.00098H14.7222C15.7044 9.00098 16.4999 9.79653 16.4999 10.7788V15.2232C16.4999 16.2054 15.7044 17.001 14.7222 17.001Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7222 6.33431H12.0555C11.0733 6.33431 10.2777 5.53875 10.2777 4.55653V2.77875C10.2777 1.79653 11.0733 1.00098 12.0555 1.00098H14.7222C15.7044 1.00098 16.4999 1.79653 16.4999 2.77875V4.55653C16.4999 5.53875 15.7044 6.33431 14.7222 6.33431Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.27766 1.00098H4.94432C5.92655 1.00098 6.7221 1.79653 6.7221 2.77875V7.2232C6.7221 8.20542 5.92655 9.00098 4.94432 9.00098H2.27766C1.29543 9.00098 0.499878 8.20542 0.499878 7.2232V2.77875C0.499878 1.79653 1.29543 1.00098 2.27766 1.00098Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.27766 11.6677H4.94432C5.92655 11.6677 6.7221 12.4633 6.7221 13.4455V15.2233C6.7221 16.2055 5.92655 17.0011 4.94432 17.0011H2.27766C1.29543 17.0011 0.499878 16.2055 0.499878 15.2233V13.4455C0.499878 12.4633 1.29543 11.6677 2.27766 11.6677Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const PlaySquareIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.55859 6.38593L11.0093 8.42682C11.4457 8.68459 11.4457 9.31659 11.0093 9.57437L7.55859 11.6153C7.11415 11.8784 6.55237 11.5575 6.55237 11.041V6.96015C6.55237 6.44371 7.11415 6.12282 7.55859 6.38593V6.38593Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8332 17.001H3.16654C1.69366 17.001 0.499878 15.8072 0.499878 14.3343V3.66764C0.499878 2.19475 1.69366 1.00098 3.16654 1.00098H13.8332C15.3061 1.00098 16.4999 2.19475 16.4999 3.66764V14.3343C16.4999 15.8072 15.3061 17.001 13.8332 17.001Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const WalletIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.5529 4.75067L11.5615 2.09543C11.0252 1.38034 10.0236 1.20878 9.27989 1.70461L4.65173 4.79005"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5528 8.57959H15.658C16.1231 8.57959 16.5001 8.95661 16.5001 9.4217V11.948C16.5001 12.4131 16.1231 12.7901 15.658 12.7901H13.5528C12.3901 12.7901 11.4475 11.8476 11.4475 10.6849V10.6849C11.4475 9.52215 12.3901 8.57959 13.5528 8.57959V8.57959Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.658 8.57951V6.8953C15.658 5.7326 14.7155 4.79004 13.5528 4.79004H2.60539C1.44268 4.79004 0.500122 5.7326 0.500122 6.8953V14.4742C0.500122 15.637 1.44268 16.5795 2.60539 16.5795H13.5528C14.7155 16.5795 15.658 15.637 15.658 14.4742V12.79"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StarIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.9068 16.4371C4.47996 16.6599 3.96358 16.6207 3.5753 16.336C3.18702 16.0512 2.99438 15.5705 3.07856 15.0965L3.75983 11.1916L0.891575 8.44288C0.54098 8.10854 0.412492 7.60313 0.560841 7.14195C0.709189 6.68076 1.10824 6.34504 1.58801 6.2778L5.57039 5.70852L7.36831 2.12194C7.58149 1.6918 8.02006 1.41968 8.50012 1.41968C8.98019 1.41968 9.41876 1.6918 9.63193 2.12194L11.4299 5.70852L15.4122 6.2778C15.892 6.34504 16.2911 6.68076 16.4394 7.14195C16.5878 7.60313 16.4593 8.10854 16.1087 8.44288L13.2404 11.1916L13.9217 15.0973C14.0059 15.5714 13.8132 16.0521 13.4249 16.3368C13.0367 16.6215 12.5203 16.6608 12.0934 16.438L8.50012 14.5811L4.9068 16.4371Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SquareMagicIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.10411 12.7763C8.10411 10.9098 9.61722 9.39672 11.4837 9.39672C9.61722 9.39672 8.10411 7.88361 8.10411 6.01709C8.10411 7.88361 6.591 9.39672 4.72449 9.39672C6.591 9.39672 8.10411 10.9098 8.10411 12.7763Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9654 6.06944C13.9654 4.66955 15.1002 3.53472 16.5001 3.53472C15.1002 3.53472 13.9654 2.39989 13.9654 1C13.9654 2.39989 12.8306 3.53472 11.4307 3.53472C12.1029 3.53472 12.7476 3.80177 13.223 4.27712C13.6983 4.75248 13.9654 5.39719 13.9654 6.06944V6.06944Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.7084 8.55173V13.6212C15.7084 15.4877 14.1953 17.0008 12.3288 17.0008H3.87975C2.01323 17.0008 0.500122 15.4877 0.500122 13.6212V5.17211C0.500122 3.30559 2.01323 1.79248 3.87975 1.79248H8.94919"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const XIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.500122 1.00049L8.50012 9.00049"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.50012 1.00049L0.500122 9.00049"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const DocumentsDrawerIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.1668 11.6672V12.5561C11.1668 13.047 10.7689 13.445 10.2779 13.445H6.72238C6.23147 13.445 5.8335 13.047 5.8335 12.5561V11.6672"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.500122 10.0442V15.2227C0.500122 16.2046 1.29606 17.0005 2.2779 17.0005H14.7223C15.7042 17.0005 16.5001 16.2046 16.5001 15.2227V10.0442C16.5001 9.35209 16.3991 8.66371 16.2002 8.00082L14.4802 2.26742C14.2546 1.51545 13.5625 1.00048 12.7774 1.00049H4.22284C3.43776 1.00049 2.74563 1.51545 2.52004 2.26742L0.800042 8.00082C0.601165 8.66371 0.500127 9.35209 0.500122 10.0442Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.4225 9.0006H0.577759" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.6113 3.6671H5.38904" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5001 6.33385H4.50012" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const DocumentIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="16" {...props} height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.43274 4.56724H7.99994" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.43274 8.13438H7.99994" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.43274 11.7015H7.99994" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.80023 16.9525L4.83143 15.4677C4.57995 15.3419 4.28476 15.3419 4.03416 15.4677L1.51126 16.7296C1.21429 16.8776 0.865601 16.6627 0.865601 16.3309V1.8918C0.865601 1.39953 1.26513 1 1.7574 1H14.2426C14.7349 1 15.1344 1.39953 15.1344 1.8918V16.3309C15.1344 16.6627 14.7857 16.8776 14.4887 16.7296L11.9658 15.4677C11.7143 15.3419 11.4192 15.3419 11.1686 15.4677L8.19976 16.9525C8.07402 17.0158 7.92598 17.0158 7.80023 16.9525V16.9525Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.5672 4.55838C11.5646 4.55838 11.5628 4.56017 11.5628 4.56284C11.5628 4.56552 11.5646 4.5673 11.5672 4.5673C11.5699 4.5673 11.5717 4.56552 11.5717 4.56284C11.5717 4.56017 11.5699 4.55838 11.5672 4.55838"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.5672 8.12552C11.5646 8.12552 11.5628 8.12731 11.5628 8.12998C11.5628 8.13266 11.5646 8.13444 11.5672 8.13444C11.5699 8.13444 11.5717 8.13266 11.5717 8.12998C11.5717 8.12731 11.5699 8.12552 11.5672 8.12552"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.5672 11.6927C11.5646 11.6927 11.5628 11.6944 11.5628 11.6971C11.5628 11.6998 11.5646 11.7016 11.5672 11.7016C11.5699 11.7016 11.5717 11.6998 11.5717 11.6971C11.5717 11.6944 11.5699 11.6927 11.5672 11.6927"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
export const SaveIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.2019 1H2.28454C1.29787 1 0.49965 1.80356 0.506761 2.79111L0.599205 15.2356C0.606317 16.2124 1.40009 17 2.37698 17H14.7157C15.6979 17 16.4934 16.2044 16.4934 15.2222V5.29156C16.4934 4.82044 16.3059 4.368 15.9725 4.03467L13.4588 1.52089C13.1254 1.18756 12.6739 1 12.2019 1Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.0497 1V4.47467C12.0497 4.96533 11.6515 5.36356 11.1608 5.36356H5.82749C5.33682 5.36356 4.9386 4.96533 4.9386 4.47467V1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.05615 17V10.1431C4.05615 9.512 4.56815 9 5.19926 9H11.8028C12.433 9 12.945 9.512 12.945 10.1431V17"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeProcessingIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.9073 8.60918V2.42529" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.30452 12.0037H2.90132C1.57506 12.0037 0.500122 10.9287 0.500122 9.60248V2.42529"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.21178 6.4153L1.36856 3.86443C0.834689 3.58269 0.500122 3.02881 0.500122 2.42531V2.3989C0.500122 1.51445 1.21648 0.798096 2.10092 0.798096H13.2801C14.179 0.798096 14.9073 1.52646 14.9073 2.42531V2.44132C14.9073 3.03521 14.5784 3.58109 14.0525 3.85803L9.19567 6.4161C8.2616 6.90755 7.14585 6.90755 6.21178 6.4153Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5004 11.6003C16.5004 13.5893 14.8883 15.2021 12.8994 15.2021C10.952 15.2029 9.29595 13.5469 9.29675 11.5995C9.29755 9.61054 10.9096 7.99854 12.8986 7.99854C14.8875 7.99854 16.5004 9.61134 16.5004 11.6003"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.804 10.251V11.8142L14.0334 12.5641"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const WordFileIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.0555 5.44444H12.5C12.0091 5.44444 11.6111 5.04648 11.6111 4.55556V1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="0.94458"
            y="5.44458"
            width="8.88889"
            height="8.88889"
            rx="3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.38892 8.33325L3.83336 11.4444H4.1258L5.38892 8.7777L6.65203 11.4444H6.94447L7.38892 8.33325"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.61145 5.44444V2.77778C3.61145 1.79594 4.40739 1 5.38923 1H11.7643C12.2358 1 12.6879 1.18747 13.0212 1.52089L15.535 4.03467C15.8684 4.36799 16.0559 4.8201 16.0559 5.29156V15.2222C16.0559 16.2041 15.26 17 14.2781 17H5.38923C4.40739 17 3.61145 16.2041 3.61145 15.2222V14.3333"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CreditCartsIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.945 13.3333V7.99976C12.9451 7.52821 12.7578 7.07593 12.4244 6.7425C12.0909 6.40906 11.6387 6.22179 11.1671 6.22192H2.27796C1.80641 6.22179 1.35413 6.40906 1.02069 6.7425C0.687258 7.07593 0.499992 7.52821 0.500122 7.99976V13.3333C0.499992 13.8048 0.687258 14.2571 1.02069 14.5905C1.35413 14.924 1.80641 15.1112 2.27796 15.1111H11.1671C12.149 15.1111 12.945 14.3151 12.945 13.3333Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M0.500122 9.84778H12.945" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M3.34448 6.22191L4.42007 2.20401C4.54211 1.74865 4.84033 1.36057 5.24892 1.12542C5.65752 0.890274 6.14289 0.827385 6.59792 0.950636L15.1849 3.25293C15.6402 3.37497 16.0283 3.67319 16.2634 4.08178C16.4986 4.49037 16.5615 4.97575 16.4382 5.43078L15.0604 10.5776C14.8152 11.5039 13.8778 12.0672 12.9448 11.8488"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EyeOffIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.773 10.8283C10.2048 11.7865 9.10104 12.2907 8.00474 12.093C6.90845 11.8953 6.05039 11.0372 5.85267 9.9409C5.65495 8.84461 6.15918 7.74086 7.11733 7.17261"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.8279 13.8836C12.2954 15.046 10.4233 15.6725 8.49987 15.6667C5.31266 15.7234 2.36779 13.9718 0.896309 11.144C0.367734 10.0726 0.367734 8.81628 0.896309 7.74489C1.63222 6.27938 2.80534 5.07876 4.2534 4.30908"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.9878 11.3408C16.0235 11.2733 16.0699 11.2127 16.1036 11.1438C16.6322 10.0724 16.6322 8.81609 16.1036 7.7447C14.6321 4.91692 11.6872 3.16528 8.5 3.22204C8.30018 3.22204 8.10595 3.24871 7.90869 3.2617"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.4999 16.5555L1.38879 1.44434" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const EyeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.3859 5.1155C11.4268 6.15639 11.4268 7.84616 10.3859 8.88883C9.34502 9.92972 7.65524 9.92972 6.61258 8.88883C5.57169 7.84794 5.57169 6.15816 6.61258 5.1155C7.65524 4.07283 9.34413 4.07283 10.3859 5.1155"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.499878 7.00005C0.499878 6.41428 0.634989 5.83472 0.896322 5.3005V5.3005C2.24299 2.54761 5.21899 0.777832 8.49988 0.777832C11.7808 0.777832 14.7568 2.54761 16.1034 5.3005V5.3005C16.3648 5.83472 16.4999 6.41428 16.4999 7.00005C16.4999 7.58583 16.3648 8.16539 16.1034 8.69961V8.69961C14.7568 11.4525 11.7808 13.2223 8.49988 13.2223C5.21899 13.2223 2.24299 11.4525 0.896322 8.69961V8.69961C0.634989 8.16539 0.499878 7.58583 0.499878 7.00005Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeOpenIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.921021 6.89478V14.4737C0.921021 15.8691 2.05197 17 3.44734 17H13.5526C14.948 17 16.0789 15.8691 16.0789 14.4737V6.89478"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.09903 5.01263L7.03461 1.47326C7.91461 0.841684 9.09945 0.842527 9.97945 1.47411L14.894 5.00337C16.4679 6.13347 16.467 7.9819 14.8923 9.11032L9.96598 12.6429C9.08598 13.2745 7.90114 13.2737 7.02114 12.6421L2.09735 9.10611C0.529349 7.97937 0.530191 6.13768 2.09903 5.01263Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.5551 10.0695V8.57899C13.5551 7.64846 12.8014 6.89478 11.8709 6.89478H5.13404C4.20351 6.89478 3.44983 7.64846 3.44983 8.57899V10.0316"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const PowerPointFileIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.0554 5.44444H12.4999C12.0089 5.44444 11.611 5.04648 11.611 4.55556V1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.61133 5.44444V2.77778C3.61133 1.79594 4.40727 1 5.38911 1H11.7642C12.2357 1 12.6878 1.18747 13.0211 1.52089L15.5349 4.03467C15.8683 4.36799 16.0558 4.8201 16.0558 5.29156V15.2222C16.0558 16.2041 15.2598 17 14.278 17H5.38911C4.40727 17 3.61133 16.2041 3.61133 15.2222V14.3333"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="0.944458"
            y="5.44458"
            width="8.88889"
            height="8.88889"
            rx="3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.98181 8.09155H6.20403C6.69495 8.09155 7.09292 8.48952 7.09292 8.98044V9.42489C7.09292 9.91581 6.69495 10.3138 6.20403 10.3138H3.98181"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.98204 11.6471V8.09155" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const SquareContentError = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8334 1H3.16669C2.18447 1 1.38892 1.79556 1.38892 2.77778V15.2222C1.38892 16.2044 2.18447 17 3.16669 17H13.8334C14.8156 17 15.6111 16.2044 15.6111 15.2222V2.77778C15.6111 1.79556 14.8156 1 13.8334 1Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.94446 10.7777H12.0556" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.94446 13.4444H12.0556" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.61114 5L7.38892 7.22222" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.61114 7.22222L7.38892 5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const NewsPapersIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.9444 4.99989L14.7264 5.00412C15.7066 5.00645 16.5 5.80171 16.5 6.7819V14.7777C16.5 15.7595 15.7041 16.5554 14.7222 16.5554V16.5554C13.7404 16.5554 12.9444 15.7595 12.9444 14.7777V3.22211C12.9444 2.24027 12.1485 1.44434 11.1667 1.44434H2.27778C1.29594 1.44434 0.5 2.24027 0.5 3.22211V14.7777C0.5 15.7595 1.29594 16.5554 2.27778 16.5554H14.7222"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.83331 12.9999H3.61108" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.83331 10.3331H3.61108" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="3.61108"
            y="5"
            width="6.22222"
            height="2.66667"
            rx="0.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FilterIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.8529 9.94126L15.7537 5.04051C15.9306 4.86357 16.0294 4.6245 16.0294 4.37509V1.94119C16.0294 1.42165 15.6078 1 15.0882 1H1.91164C1.39211 1 0.970459 1.42165 0.970459 1.94119V4.37509C0.970459 4.6245 1.06928 4.86451 1.24623 5.04051L6.14698 9.94126"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.14697 9.94116V15.8226C6.14697 16.5878 6.86604 17.1497 7.60863 16.9643L9.9616 16.376C10.4849 16.2452 10.8529 15.7746 10.8529 15.2344V9.94116"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SquareContentCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8334 1H3.16669C2.18447 1 1.38892 1.79556 1.38892 2.77778V15.2222C1.38892 16.2044 2.18447 17 3.16669 17H13.8334C14.8156 17 15.6111 16.2044 15.6111 15.2222V2.77778C15.6111 1.79556 14.8156 1 13.8334 1Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.2778 5L8.05562 7.22222L6.72229 5.88889"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.94446 10.7777H12.0556" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.94446 13.4444H12.0556" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ArrowDown2Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.01061 1V17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M0.616089 10.6096L7.00007 16.9925L13.384 10.6096"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ExcelFileIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.11145 4.55556V2.77778C4.11145 1.79594 4.90739 1 5.88923 1H14.7781C15.76 1 16.5559 1.79594 16.5559 2.77778V15.2222C16.5559 16.2041 15.76 17 14.7781 17H5.88923C4.90739 17 4.11145 16.2041 4.11145 15.2222V13.4444"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <rect
            x="1.44458"
            y="4.55566"
            width="8.88889"
            height="8.88889"
            rx="2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.5558 6.40441H10.3336" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.5558 11.6669H10.3336" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.3335 1V17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.28178 10.5554L4.61511 7.44434" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.61511 10.5554L7.28178 7.44434" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const BillIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.8891 17H3.11127C2.12905 17 1.3335 16.2044 1.3335 15.2222V2.77778C1.3335 1.79556 2.12905 1 3.11127 1H12.8891C13.8713 1 14.6668 1.79556 14.6668 2.77778V15.2222C14.6668 16.2044 13.8713 17 12.8891 17Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.77795 5.00011H11.5557" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.77795 7.66661H11.5557" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.44458 11.6666H11.5557" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.44458 14.3334H11.5557" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.77794 4.33344V3.66678" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.77794 8.33328V8.99995" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M4.62058 7.85681C4.79302 8.13947 5.08814 8.33503 5.44458 8.33503H5.77791H6.17525C6.69258 8.33503 7.11125 7.91547 7.11125 7.39903C7.11125 6.9697 6.8188 6.59547 6.4028 6.49059L5.15302 6.1777C4.73702 6.07281 4.44458 5.69859 4.44458 5.26925C4.44458 4.75281 4.86414 4.33325 5.38058 4.33325H5.77791H6.11125C6.4668 4.33325 6.76102 4.52792 6.93347 4.8097"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SaveCheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M18.3157 10.7368V7.8403C18.3157 7.4183 18.148 7.01357 17.8496 6.71517L15.6007 4.4662C15.3021 4.1677 14.8973 4 14.4751 4H5.68409C4.75392 4 3.99988 4.75405 3.99988 5.68421V16.6316C3.99988 17.5617 4.75392 18.3158 5.68409 18.3158H10.7367"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.0997 4V7.47368C14.0995 7.88057 13.7697 8.21038 13.3629 8.21053H8.9418C8.53491 8.21038 8.2051 7.88057 8.20496 7.47368V4"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M7.36824 18.3156V13.5375C7.36168 12.954 7.80915 12.4656 8.391 12.4211H11.5788"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle
            cx="16.2106"
            cy="16.2106"
            r="3.78947"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M17.389 15.6223L15.9149 17.0964L15.031 16.2116"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3031 6.13112L10.0809 1.36631C9.44308 0.877895 8.55697 0.877895 7.91916 1.36631L1.69694 6.13112C1.25764 6.46752 1 6.98928 1 7.54259V15.2222C1 16.2041 1.79594 17 2.77778 17H15.2222C16.2041 17 17 16.2041 17 15.2222V7.54259C17 6.98929 16.7424 6.46753 16.3031 6.13112Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.16663 6.7925L7.91898 11.9633C8.55679 12.4517 9.4429 12.4517 10.0807 11.9633L16.8344 6.7915"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.3332 6.55566L8.55539 7.889L7.6665 7.22233"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CopyDash2Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.5946 17.0001H2.08105C1.60365 17.0001 1.21619 16.6126 1.21619 16.1352V6.6217C1.21619 6.1443 1.60365 5.75684 2.08105 5.75684H11.5946C12.072 5.75684 12.4594 6.1443 12.4594 6.6217V16.1352C12.4594 16.6126 12.072 17.0001 11.5946 17.0001Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.7838 3.1621V2.29724C16.7838 1.81983 16.3963 1.43237 15.9189 1.43237H15.0541"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.7838 11.8108V12.6757C16.7838 13.1531 16.3963 13.5405 15.9189 13.5405H15.0541"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.67566 3.1621V2.29724C4.67566 1.81983 5.06312 1.43237 5.54052 1.43237H6.40539"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M9.86487 1.43243H11.5946" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.7838 8.35131V6.62158" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const EuroIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.6569 3.34315C17.781 6.46735 17.781 11.5327 14.6569 14.6569C11.5327 17.781 6.46733 17.781 3.34315 14.6569C0.21895 11.5327 0.21895 6.46733 3.34315 3.34315C6.46735 0.21895 11.5327 0.21895 14.6569 3.34315"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.1429 12.143C10.4069 13.879 7.59355 13.879 5.85754 12.143C4.12154 10.407 4.12154 7.59367 5.85754 5.85767C7.59355 4.12166 10.4069 4.12166 12.1429 5.85767"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.99997 7.77355H3.66663" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.99997 10.2267H3.66663" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const InfoIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="8" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.11121 12.1109H10.164" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.14124 12.111V8.33325H8.11902" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M9.08891 5.66417C9.08891 5.7869 8.98942 5.88639 8.86669 5.88639C8.74396 5.88639 8.64446 5.7869 8.64446 5.66417C8.64446 5.54144 8.74396 5.44195 8.86669 5.44195"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.86666 5.44198C8.98939 5.44198 9.08888 5.54147 9.08888 5.6642"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ArrowUp2Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.51044 1.0127V16.9999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M1.12537 7.41621L7.49998 1L13.8746 7.41621"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const BuildingIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.09995 12.8001V5.6001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14.9 5.6001V12.8001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M5.30002 5.6001V12.8001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.49998 5.6001V12.8001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.7 5.6001V12.8001" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M8.50004 3.41987C8.44484 3.41987 8.40004 3.46467 8.40084 3.51987C8.40084 3.57507 8.44564 3.61987 8.50084 3.61987C8.55604 3.61987 8.60084 3.57507 8.60084 3.51987C8.60004 3.46467 8.55524 3.41987 8.50004 3.41987"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.1 5.60005H0.900024V3.48885L8.50002 0.800049L16.1 3.48885V5.60005Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7 12.8H1.3L0.5 13.6V15.2H16.5V13.6L15.7 12.8Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const MoreVerticalIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="3" height="16" viewBox="0 0 3 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.49681 13.9229C1.20066 13.9229 0.958349 14.1652 0.96158 14.4613C0.96158 14.7575 1.20389 14.9998 1.50004 14.9998C1.7962 14.9998 2.0385 14.7575 2.0385 14.4613C2.0385 14.1652 1.7962 13.9229 1.49681 13.9229"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.49681 7.46143C1.20066 7.46143 0.958349 7.70373 0.96158 7.99989C0.96158 8.29604 1.20389 8.53835 1.50004 8.53835C1.7962 8.53835 2.0385 8.29604 2.0385 7.99989C2.0385 7.70373 1.7962 7.46143 1.49681 7.46143"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.49681 1C1.20066 1 0.958349 1.24231 0.96158 1.53846C0.96158 1.83462 1.20389 2.07692 1.50004 2.07692C1.7962 2.07692 2.0385 1.83462 2.0385 1.53846C2.0385 1.24231 1.7962 1 1.49681 1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CalendarIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.49986 1V3.66667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5 1V3.66667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.5 6.7777H16.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="0.5"
            y="2.3335"
            width="16"
            height="14.6667"
            rx="3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SquaresAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6813 16.9999H2.31867C1.33645 16.9999 0.540894 16.2044 0.540894 15.2221V8.11103C0.540894 7.12881 1.33645 6.33325 2.31867 6.33325H14.6813C15.6636 6.33325 16.4591 7.12881 16.4591 8.11103V15.2221C16.4591 16.2044 15.6627 16.9999 14.6813 16.9999Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M2.08386 6.33341V5.44453C2.08386 4.4623 2.87942 3.66675 3.86164 3.66675H13.1372C14.1194 3.66675 14.915 4.4623 14.915 5.44453V6.33341"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.62549 3.66667V2.77778C3.62549 1.79556 4.42104 1 5.40327 1H11.5979C12.5802 1 13.3757 1.79556 13.3757 2.77778V3.66667"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.50011 9V14.3333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.0779 11.5777H5.92236" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const WarningCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.5 1V1C12.9187 1 16.5 4.58133 16.5 9V9C16.5 13.4187 12.9187 17 8.5 17V17C4.08133 17 0.5 13.4187 0.5 9V9C0.5 4.58133 4.08133 1 8.5 1Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.49999 9.44444V5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M8.4991 12.5555C8.37643 12.5555 8.27688 12.655 8.27777 12.7777C8.27777 12.9004 8.37732 12.9999 8.49999 12.9999C8.62266 12.9999 8.72221 12.9004 8.72221 12.7777C8.72221 12.655 8.62266 12.5555 8.4991 12.5555"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const CheckCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M15.2209 4.9502L8.50443 11.6666L5.14709 8.30842"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.5 9C16.5 13.4187 12.9187 17 8.5 17C4.08133 17 0.5 13.4187 0.5 9C0.5 4.58133 4.08133 1 8.5 1C9.79156 1 11.0076 1.31378 12.0876 1.85689"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeLockIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.6058 7.67979V3.24438" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.60871 13.014H2.27804C1.29654 13.014 0.500854 12.2183 0.500854 11.2359V3.21948"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8196 1.43164H2.28696C1.30013 1.43164 0.5 2.23177 0.5 3.21949V3.21949C0.5 3.81248 0.793382 4.36635 1.28413 4.69885L6.04492 7.92694C7.25846 8.7493 8.84984 8.7493 10.0634 7.92694L14.8224 4.69974C15.3131 4.36724 15.6065 3.81248 15.6065 3.22038V3.21949C15.6056 2.23177 14.8064 1.43164 13.8196 1.43164Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M15.353 13.0123V11.8655C15.353 11.068 14.6729 10.3452 13.8328 10.3452C12.9926 10.3452 12.3125 11.0253 12.3125 11.8655V13.0123"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.627 16.5684H12.0388C11.5569 16.5684 11.1658 16.1772 11.1658 15.6953V13.8852C11.1658 13.4034 11.5569 13.0122 12.0388 13.0122H15.627C16.1088 13.0122 16.5 13.4034 16.5 13.8852V15.6953C16.5 16.1772 16.1088 16.5684 15.627 16.5684Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StarCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.65755 16.4911C4.31588 16.6743 3.89964 16.6469 3.585 16.4203C3.27035 16.1938 3.1123 15.8078 3.17773 15.4256L3.91172 11.1781L0.803262 8.16858C0.528537 7.89841 0.430529 7.49596 0.550276 7.12973C0.670023 6.76349 0.986862 6.49668 1.36813 6.441L5.66552 5.82117L7.58505 1.95335C7.75846 1.60695 8.11262 1.38818 8.5 1.38818C8.88738 1.38818 9.24154 1.60695 9.41495 1.95335L11.3345 5.82117L15.6319 6.441C16.0131 6.49668 16.33 6.76349 16.4497 7.12973C16.5695 7.49596 16.4715 7.89841 16.1967 8.16858L13.0866 11.1764L13.8206 15.4239C13.8868 15.8063 13.7291 16.193 13.4143 16.4201C13.0994 16.6471 12.6827 16.6747 12.3408 16.4911L8.49831 14.4878L4.65755 16.4911Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.90801 8.71729L8.1466 10.4787L7.08875 9.42168"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const WarningTriangleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.50053 7.78366V5.16553" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.49983 9.88741C7.40323 9.88741 7.32482 9.96582 7.32552 10.0624C7.32552 10.159 7.40393 10.2374 7.50053 10.2374C7.59714 10.2374 7.67554 10.159 7.67554 10.0624C7.67554 9.96582 7.59714 9.88741 7.49983 9.88741"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.92056 1.49669L14.2821 10.88C14.9052 11.9706 14.1176 13.328 12.8618 13.328H2.13862C0.882053 13.328 0.0945131 11.9706 0.718245 10.88L6.07982 1.49669C6.70775 0.396936 8.29263 0.396936 8.92056 1.49669Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EqualIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 2.77778V5.22222C16.5 6.20444 15.7044 7 14.7222 7H2.27778C1.29556 7 0.5 6.20444 0.5 5.22222V2.77778C0.5 1.79556 1.29556 1 2.27778 1H14.7222C15.7044 1 16.5 1.79556 16.5 2.77778Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5 12.7778V15.2222C16.5 16.2044 15.7044 17 14.7222 17H2.27778C1.29556 17 0.5 16.2044 0.5 15.2222V12.7778C0.5 11.7956 1.29556 11 2.27778 11H14.7222C15.7044 11 16.5 11.7956 16.5 12.7778Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const StarSearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.94582 14.2906L4.66135 15.9938C4.32074 16.174 3.9075 16.146 3.5943 15.9215C3.2811 15.697 3.12186 15.3147 3.18311 14.9342L3.91645 10.7173L0.809762 7.73149C0.532114 7.46468 0.431968 7.06234 0.552143 6.69651C0.672317 6.33068 0.991542 6.06611 1.37332 6.01592L5.66669 5.4008L7.58404 1.56077C7.75878 1.21673 8.11195 1 8.49782 1C8.88369 1 9.23686 1.21673 9.4116 1.56077L11.3334 5.4008L15.6268 6.01414C16.0083 6.06431 16.3274 6.3286 16.4477 6.69414C16.568 7.05967 16.4683 7.46182 16.1912 7.72882L14.4383 9.41328"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.359 12.0292C15.044 12.7126 15.2495 13.7415 14.8798 14.6356C14.51 15.5298 13.6377 16.1129 12.6701 16.1129C11.7025 16.1129 10.8303 15.5298 10.4605 14.6356C10.0907 13.7415 10.2963 12.7126 10.9812 12.0292C11.9144 11.0974 13.4259 11.0974 14.359 12.0292"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M15.9486 17L14.3593 15.4106" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const UserSquareIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7222 17H2.27778C1.29556 17 0.5 16.2044 0.5 15.2222V2.77778C0.5 1.79556 1.29556 1 2.27778 1H14.7222C15.7044 1 16.5 1.79556 16.5 2.77778V15.2222C16.5 16.2044 15.7044 17 14.7222 17Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M13.148 14.6285L12.8653 13.9191C12.7222 13.5591 12.5009 13.2365 12.2164 12.9734L12.1649 12.9254C11.7177 12.5111 11.1311 12.28 10.5213 12.28H6.47685C5.86707 12.28 5.27952 12.5111 4.83241 12.9245L4.78085 12.9725C4.4973 13.2356 4.27596 13.5583 4.13196 13.9183L3.85107 14.6285"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.4965 5.38218C11.5987 6.4844 11.5987 8.27195 10.4965 9.37506C9.3943 10.4782 7.60675 10.4773 6.50364 9.37506C5.40052 8.27284 5.40141 6.48529 6.50364 5.38218C7.60586 4.27906 9.39341 4.27995 10.4965 5.38218"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const TableIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7222 17H2.27778C1.29556 17 0.5 16.2044 0.5 15.2222V2.77778C0.5 1.79556 1.29556 1 2.27778 1H14.7222C15.7044 1 16.5 1.79556 16.5 2.77778V15.2222C16.5 16.2044 15.7044 17 14.7222 17Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M0.5 6.33336H16.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M0.5 11.6666H16.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.49999 6.33325V16.9999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const StarErrorIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.4452 9.86396L16.1985 8.16797" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.66357 16.4878L7.94939 14.7742" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M16.1986 8.17126C16.4723 7.90185 16.5698 7.50055 16.4501 7.13556C16.3304 6.77058 16.0142 6.50494 15.6341 6.45L11.3372 5.83412L9.41629 1.98044C9.24232 1.63524 8.88872 1.41748 8.50216 1.41748C8.1156 1.41748 7.762 1.63524 7.58803 1.98044L5.66962 5.83412L1.37278 6.45168C0.990296 6.50297 0.670866 6.76855 0.550609 7.13524C0.430352 7.50194 0.530468 7.9051 0.808294 8.17294L3.91634 11.1698L3.18419 15.4034C3.12311 15.7842 3.28246 16.1667 3.59576 16.3916C3.90907 16.6164 4.32252 16.6448 4.66365 16.465"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M11.8842 13.2263L14.4201 15.7615" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M11.8842 15.7615L14.4201 13.2263" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const ComputerEnvelopeIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.2776 10.7778H2.72201C1.98563 10.7778 1.38867 10.1808 1.38867 9.44444V2.77778C1.38867 1.79594 2.18461 1 3.16645 1H5.83312"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.7213 17.0001H2.27853C1.72077 17.0001 1.19535 16.7383 0.859459 16.293C0.523568 15.8477 0.416158 15.2706 0.569363 14.7343L1.51542 11.4226C1.62443 11.0409 1.97324 10.7778 2.37014 10.7778H14.6297C15.0266 10.7778 15.3754 11.0409 15.4844 11.4226L16.4305 14.7343C16.5837 15.2706 16.4763 15.8477 16.1404 16.293C15.8045 16.7383 15.2791 17.0001 14.7213 17.0001Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M4.94446 7.22228H5.83335" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.05554 4.55553H5.83332" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <rect
            x="8.49976"
            y="1"
            width="8"
            height="6.22222"
            rx="2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.7219 3.22217L12.0605 3.99337C12.3323 4.15029 12.6672 4.15029 12.939 3.99337L14.2775 3.22217"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.72229 14.3334H10.2778" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const StorageDownloadIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.50047 1.44434V9.44434" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M5.83386 6.77759L8.50053 9.44425L11.1672 6.77759"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M5.83382 4.11108H4.39916C3.65782 4.11108 2.99471 4.57064 2.73427 5.26486L0.613377 10.92C0.538711 11.12 0.500488 11.3315 0.500488 11.5449V14.7778C0.500488 15.76 1.29604 16.5555 2.27827 16.5555H14.7227C15.7049 16.5555 16.5005 15.76 16.5005 14.7778V11.5449C16.5005 11.3315 16.4623 11.12 16.3876 10.9209L14.2667 5.26486C14.0063 4.57064 13.3432 4.11108 12.6018 4.11108H11.1672"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M0.530884 11.2222H4.39577C4.73266 11.2222 5.04022 11.4124 5.19044 11.7137L5.58777 12.5084C5.73888 12.8097 6.04644 12.9999 6.38333 12.9999H10.618C10.9549 12.9999 11.2624 12.8097 11.4127 12.5084L11.81 11.7137C11.9611 11.4124 12.2687 11.2222 12.6056 11.2222H16.4704"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ReceiptDivisionIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.63281 10.8667L10.3662 7.1333" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M10.5352 10.7362C10.6187 10.8197 10.6187 10.9548 10.5352 11.0375C10.4516 11.1211 10.3165 11.1211 10.2338 11.0375C10.1503 10.9539 10.1503 10.8188 10.2338 10.7362C10.3165 10.6526 10.4516 10.6526 10.5352 10.7362"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.76622 6.9628C6.84977 7.04636 6.84977 7.18147 6.76622 7.26414C6.68266 7.3477 6.54755 7.3477 6.46488 7.26414C6.38221 7.18059 6.38132 7.04547 6.46488 6.9628C6.54844 6.88014 6.68355 6.87925 6.76622 6.9628"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.38928 2.58047V15.6669C1.38928 16.3273 2.0844 16.7576 2.67552 16.4615L3.36087 16.1184C3.61154 15.9931 3.90576 15.9931 4.15554 16.1184L5.73156 16.906C5.98135 17.0313 6.27646 17.0313 6.52624 16.906L8.10226 16.1184C8.35205 15.9931 8.64716 15.9931 8.89694 16.1184L10.473 16.906C10.7236 17.0313 11.0179 17.0313 11.2685 16.906L12.8428 16.1184C13.0934 15.9931 13.3877 15.9931 13.6383 16.1184L14.3246 16.4615C14.9166 16.7576 15.6117 16.3273 15.6117 15.6669V2.58047C15.6117 1.70757 14.9041 1 14.0312 1H2.96975C2.09685 1 1.38928 1.70757 1.38928 2.58047Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ArrowCircleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.49813 1C4.46468 1.00062 1.06261 4.00401 0.56186 8.00626C0.0611056 12.0085 2.61832 15.7575 6.52728 16.7519C10.4362 17.7462 14.474 15.6749 15.9466 11.9198C17.4191 8.16476 15.8657 3.9008 12.3228 1.97292"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M12.3226 5.04769V1.51196H15.8584" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const SquareAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5 17H2.5C1.395 17 0.5 16.105 0.5 15V3C0.5 1.895 1.395 1 2.5 1H14.5C15.605 1 16.5 1.895 16.5 3V15C16.5 16.105 15.605 17 14.5 17Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M8.5 5V13" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12.5 9H4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const MedalIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="13" {...props} height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M2.94446 10.3003V16.9998L6.50001 15.2221L10.0556 16.9998V10.3003"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.2712 2.5621C12.354 4.6449 12.354 8.02178 10.2712 10.1046C8.1884 12.1874 4.81152 12.1874 2.72873 10.1046C0.645926 8.02177 0.645926 4.64489 2.72873 2.5621C4.81153 0.4793 8.1884 0.4793 10.2712 2.5621"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ReceiPtErrorBarIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.94446 11.6669H12.0557" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.61117 5.88892L7.38892 8.11117" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.61117 8.11117L7.38892 5.88892" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.38879 2.58047V15.6669C1.38879 16.3273 2.08391 16.7576 2.67503 16.4615L3.36038 16.1184C3.61105 15.9931 3.90527 15.9931 4.15505 16.1184L5.73108 16.906C5.98086 17.0313 6.27597 17.0313 6.52575 16.906L8.10178 16.1184C8.35156 15.9931 8.64667 15.9931 8.89645 16.1184L10.4725 16.906C10.7231 17.0313 11.0174 17.0313 11.268 16.906L12.8423 16.1184C13.093 15.9931 13.3872 15.9931 13.6379 16.1184L14.3241 16.4615C14.9161 16.7576 15.6112 16.3273 15.6112 15.6669V2.58047C15.6112 1.70757 14.9036 1 14.0307 1H2.96926C2.09636 1 1.38879 1.70757 1.38879 2.58047Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const MoreHorizontalIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="4" viewBox="0 0 15 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14.4998 1.99989C14.4998 2.29727 14.2587 2.53835 13.9613 2.53835C13.6639 2.53835 13.4229 2.29727 13.4229 1.99989C13.4229 1.7025 13.6639 1.46143 13.9613 1.46143C14.2587 1.46143 14.4998 1.7025 14.4998 1.99989"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.03859 1.99989C8.03859 2.29727 7.79752 2.53835 7.50013 2.53835C7.20275 2.53835 6.96167 2.29727 6.96167 1.99989C6.96167 1.7025 7.20275 1.46143 7.50013 1.46143C7.79752 1.46143 8.03859 1.7025 8.03859 1.99989"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.57692 1.99989C1.57692 2.29727 1.33585 2.53835 1.03846 2.53835C0.741077 2.53835 0.5 2.29727 0.5 1.99989C0.5 1.7025 0.741077 1.46143 1.03846 1.46143C1.33585 1.46143 1.57692 1.7025 1.57692 1.99989"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const LogInIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.5 9H0.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M7.49902 4L12.5 9.001L7.49902 14.001"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.5 1H14.5C15.605 1 16.5 1.895 16.5 3V15C16.5 16.105 15.605 17 14.5 17H12.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const EnvelopeVerifyBadgeCheckIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.2113 5.21069H14.5965C15.6913 5.21069 16.5788 6.09826 16.5788 7.19383V7.19383C16.5788 7.8515 16.2529 8.46623 15.709 8.83507C14.5814 9.59969 12.5612 10.9689 10.8888 12.1024C9.74777 12.8763 8.25137 12.8754 7.11033 12.1024C5.48846 11.0035 3.43206 9.60895 2.2885 8.83422C1.74451 8.46455 1.42114 7.8515 1.42114 7.19383V7.19383C1.42114 6.09826 2.30871 5.21069 3.40427 5.21069H4.78952"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M1.42114 7.19385V14.4738C1.42114 15.8691 2.55207 17 3.94742 17H14.0526C15.4479 17 16.5788 15.8691 16.5788 14.4738V7.19385"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.3093 4.55542L8.67144 6.19329L7.68872 5.21057"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.02012 5.8953L5.57927 6.62708L5.70053 7.53739C5.7679 8.04264 6.16452 8.44011 6.66978 8.50748L7.58261 8.62958L8.31355 9.18873C8.71775 9.49778 9.27943 9.49778 9.68363 9.18873L10.4154 8.62958H10.4146L11.3257 8.50832C11.831 8.44095 12.2284 8.04433 12.2958 7.53907L12.4179 6.62624C12.4179 6.62708 12.7009 6.25656 12.9771 5.8953C13.2861 5.4911 13.2861 4.92942 12.9771 4.52522L12.4179 3.79344L12.2967 2.88313C12.2293 2.37788 11.8327 1.98041 11.3274 1.91304L10.4146 1.79094L9.68363 1.23179C9.27943 0.922738 8.71775 0.922738 8.31355 1.23179L7.58177 1.79094H7.58261L6.67062 1.9122C6.16536 1.97957 5.7679 2.37619 5.70053 2.88145L5.57927 3.79428C5.57927 3.79344 5.29632 4.16396 5.02012 4.52522C4.71107 4.93026 4.71107 5.4911 5.02012 5.8953Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ReceiptCheckBarIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.55552 8.11118L6.22217 6.77783" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.7778 5.88892L7.55554 8.11117" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M4.44446 11.6669H11.5557" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.3334 1H2.6666C1.68436 1 0.888794 1.79557 0.888794 2.7778V15.6669C0.888794 16.3273 1.58391 16.7576 2.17503 16.4615L2.86038 16.1184C3.11105 15.9931 3.40527 15.9931 3.65505 16.1184L5.23108 16.906C5.48086 17.0313 5.77597 17.0313 6.02575 16.906L7.60178 16.1184C7.85156 15.9931 8.14667 15.9931 8.39645 16.1184L9.97247 16.906C10.2231 17.0313 10.5174 17.0313 10.768 16.906L12.3423 16.1184C12.593 15.9931 12.8872 15.9931 13.1379 16.1184L13.8241 16.4615C14.4161 16.7576 15.1112 16.3273 15.1112 15.6669V2.7778C15.1112 1.79557 14.3156 1 13.3334 1V1Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const AtIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.5556 9C12.5556 10.9636 10.9636 12.5556 9 12.5556C7.03644 12.5556 5.44444 10.9636 5.44444 9C5.44444 7.03644 7.03644 5.44444 9 5.44444V5.44444C10.9636 5.44444 12.5556 7.03644 12.5556 9V10.3333C12.5556 11.5609 13.5502 12.5556 14.7778 12.5556C16.0053 12.5556 17 11.5609 17 10.3333V9C17 4.58133 13.4187 1 9 1C4.58133 1 1 4.58133 1 9C1 13.4187 4.58133 17 9 17C10.0213 17 11.0596 16.8062 12.0613 16.3911C12.6018 16.1671 13.1013 15.8862 13.5627 15.5653"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const SettingIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.91469 14.8969L6.38225 15.9484C6.66621 16.588 7.30031 17 8.00003 17V17C8.69975 17 9.33384 16.588 9.61781 15.9484L10.0854 14.8969C10.2518 14.5238 10.5318 14.2127 10.8854 14.008V14.008C11.2412 13.8027 11.6528 13.7153 12.0614 13.7582L13.2054 13.88C13.9011 13.9536 14.5749 13.6104 14.9245 13.0044V13.0044C15.2745 12.3988 15.2348 11.6438 14.8231 11.0782L14.1458 10.1476C13.9046 9.8137 13.7758 9.41185 13.7778 9V9C13.7777 8.58927 13.9078 8.18908 14.1494 7.85689L14.8267 6.92622C15.2384 6.36067 15.2781 5.60563 14.928 5V5C14.5784 4.39401 13.9046 4.05085 13.2089 4.12444L12.0649 4.24622C11.6564 4.28913 11.2447 4.2017 10.8889 3.99644V3.99644C10.5346 3.7906 10.2546 3.47789 10.0889 3.10311L9.61781 2.05156C9.33384 1.41205 8.69975 1 8.00003 1V1C7.30031 1 6.66621 1.41205 6.38225 2.05156L5.91469 3.10311C5.74904 3.47789 5.46899 3.7906 5.11469 3.99644V3.99644C4.75887 4.2017 4.34723 4.28913 3.93869 4.24622L2.79114 4.12444C2.09542 4.05085 1.42164 4.39401 1.07203 5V5C0.721964 5.60563 0.761684 6.36067 1.17336 6.92622L1.85069 7.85689C2.09225 8.18908 2.22232 8.58927 2.22225 9V9C2.22232 9.41073 2.09225 9.81092 1.85069 10.1431L1.17336 11.0738C0.761684 11.6393 0.721964 12.3944 1.07203 13V13C1.42197 13.6056 2.0955 13.9487 2.79114 13.8756L3.93514 13.7538C4.34367 13.7109 4.75531 13.7983 5.11114 14.0036V14.0036C5.46676 14.2088 5.74811 14.5216 5.91469 14.8969V14.8969Z"
            stroke="currentColor"
        />
        <circle
            cx="7.99998"
            cy="9.00011"
            r="2.35289"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const ReceiptArrowBack = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.66677 8.9998L4.44458 6.77761L6.66677 4.55542"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.93247 16.8673L8.43827 15.8718C8.17249 15.6949 7.82672 15.6949 7.56183 15.8718L6.06763 16.8673C5.80186 17.0442 5.45609 17.0442 5.1912 16.8673L3.69789 15.8709C3.43211 15.694 3.08634 15.694 2.82146 15.8709L2.11747 16.3402C1.59214 16.6904 0.889038 16.3136 0.889038 15.6834V2.58042C0.889038 1.70755 1.59658 1 2.46946 1H13.5306C14.4035 1 15.1111 1.70755 15.1111 2.58042V15.6834C15.1111 16.3145 14.408 16.6904 13.8826 16.3411L13.1786 15.8718C12.9129 15.6949 12.5671 15.6949 12.3022 15.8718L10.808 16.8673C10.5431 17.0442 10.1974 17.0442 9.93247 16.8673V16.8673Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.44458 6.77759H9.11118C10.4614 6.77759 11.5556 7.87179 11.5556 9.222V9.222C11.5556 10.5722 10.4614 11.6664 9.11118 11.6664H8.00009"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const PaperPlaneIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.9961 7.23532L7.58751 14.3962C7.7861 15.2885 8.97134 15.4808 9.44131 14.6972L16.8538 2.34248C17.2591 1.66854 16.7738 0.811279 15.9876 0.811279H2.01354C1.11225 0.811279 0.661159 1.90037 1.29826 2.53748L5.9961 7.23532Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M16.8567 1.31445L5.99268 7.23618" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const FileSearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.44449 17H12.4445C13.6718 17 14.6667 16.0051 14.6667 14.7778V5.77482C14.6667 5.06757 14.3858 4.3893 13.8857 3.8892L11.7775 1.78105C11.2774 1.28095 10.5991 1 9.89189 1H3.5556C2.3283 1 1.33337 1.99492 1.33337 3.22222V8.11111"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.6458 5.44444H11.5556C10.8192 5.44444 10.2223 4.84749 10.2223 4.11111V1.021"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <ellipse
            cx="4.54324"
            cy="12.9012"
            rx="2.5679"
            ry="2.5679"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M2.72747 14.717L1.33337 16.1111" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export const PictureIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.5002 12.5557L12.6842 8.73967C12.3367 8.39212 11.774 8.39212 11.4273 8.73967L7.61133 12.5557"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8336 17H3.16691C1.69402 17 0.500244 15.8062 0.500244 14.3333V3.66667C0.500244 2.19378 1.69402 1 3.16691 1H13.8336C15.3065 1 16.5002 2.19378 16.5002 3.66667V14.3333C16.5002 15.8062 15.3065 17 13.8336 17Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.0556 17L6.46182 11.4062C6.11426 11.0586 5.5516 11.0586 5.20493 11.4062L0.896484 15.7146"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M6.06931 6.09766C6.19948 6.22783 6.19948 6.43889 6.06931 6.56906C5.93913 6.69924 5.72808 6.69924 5.5979 6.56906C5.46773 6.43889 5.46773 6.22783 5.5979 6.09766C5.72808 5.96748 5.93913 5.96748 6.06931 6.09766"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const FileMedalIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.4781 6.80747V5.0055C12.4781 4.56579 12.303 4.1435 11.9919 3.83239L9.64572 1.48617C9.3346 1.17505 8.91231 1 8.47261 1H2.52244C1.60569 1 0.863159 1.74253 0.863159 2.65928V14.2742C0.863159 15.191 1.60569 15.9335 2.52244 15.9335H7.50027"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.4783 5.14819H9.15972C8.70176 5.14819 8.33008 4.77652 8.33008 4.31856V1"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <circle
            cx="11.6487"
            cy="11.7853"
            r="2.48892"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.0709 16.7632V13.8271" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.2267 13.8271V16.7632" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M10.2269 16.7632L11.6489 16.4073L13.0709 16.7632"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const QuestionMessageBubleIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.43433 6.95799C6.6446 6.05172 7.47003 5.42336 8.39957 5.46194C9.43988 5.40432 10.3317 6.19706 10.3965 7.23696C10.3965 8.57169 8.48832 9.01198 8.48832 9.89949"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.59913 12.3404C8.59905 12.4016 8.54937 12.4512 8.48814 12.4512C8.42691 12.4512 8.37728 12.4015 8.37725 12.3403C8.37722 12.2791 8.42681 12.2294 8.48805 12.2293C8.51752 12.2293 8.54579 12.241 8.56663 12.2618C8.58747 12.2826 8.59917 12.3109 8.59913 12.3404"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.94852 13.5901C-0.431771 10.1926 0.179922 5.53924 3.35739 2.87232C6.53486 0.20539 11.2238 0.409804 14.1571 3.34313C17.0904 6.27646 17.2949 10.9654 14.6279 14.1429C11.961 17.3203 7.30766 17.932 3.91015 15.5517L1.38808 16.1122L1.94852 13.5901Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const DrawerDocumentFileUpIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0.500244 8.80005V13.6C0.500244 14.4837 1.21659 15.2 2.10024 15.2H14.9002C15.7839 15.2 16.5002 14.4837 16.5002 13.6V8.80005"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.30105 5.6001H1.7983C1.41696 5.6001 1.08863 5.86926 1.01383 6.24319L0.516155 8.73146C0.469147 8.96648 0.529989 9.2102 0.68194 9.39555C0.833892 9.5809 1.06094 9.68836 1.30062 9.68836H4.73532C5.03846 9.68836 5.31557 9.8597 5.45102 10.1309L5.8257 10.8811C5.96115 11.1523 6.23825 11.3237 6.5414 11.3237H10.4585C10.7615 11.3237 11.0385 11.1525 11.174 10.8814L11.5494 10.1306C11.685 9.85956 11.962 9.68836 12.265 9.68836H15.7001C15.9398 9.68836 16.1668 9.5809 16.3188 9.39555C16.4707 9.2102 16.5315 8.96648 16.4845 8.73146L15.9869 6.24319C15.9121 5.86926 15.5837 5.6001 15.2024 5.6001H13.6992"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M6.09985 4.80015H10.8999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6.09985 7.20005H10.8999" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M3.2998 9.68831V2.40005C3.2998 1.51639 4.01615 0.800049 4.8998 0.800049H10.59C11.0144 0.800048 11.4213 0.96862 11.7214 1.26868L13.2312 2.77845C13.5312 3.07851 13.6998 3.48547 13.6998 3.90982V9.68828"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export const LanguageIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props} width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.26441 1V4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.4997 17L12.735 8L8.97034 17" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.80811 15H15.6622" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M0.499756 12C4.35387 11.676 7.72423 8.095 8.03011 4H0.500697"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.02912 12C5.62065 11.798 3.51336 9.559 3.32324 7"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
